


  
  

  var faError = {
    prefix: 'fak',
    iconName: 'error',
    icon: [
      512,
      512,
      [],
      'e046',
      
      'M256 300c-13.3 0-24-10.7-24-24V148c0-13.3 10.7-24 24-24s24 10.7 24 24l0 128c0 13.3-10.7 24-24 24zm0 40a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM18.5 224C7 243.8 7 268.2 18.5 288l91 157.7c11.4 19.8 32.6 32 55.4 32l182.1 0c22.9 0 44-12.2 55.4-32l91-157.7c11.4-19.8 11.4-44.2 0-64l-91-157.7c-11.4-19.8-32.6-32-55.4-32l-182.1 0c-22.9 0-44 12.2-55.4 32L18.5 224zM151.1 90.3c2.9-5 8.1-8 13.9-8l182.1 0c5.7 0 11 3 13.9 8L452 248c2.9 5 2.9 11 0 16l-91 157.7c-2.9 5-8.1 8-13.9 8l-182.1 0c-5.7 0-11-3-13.9-8L60 264c-2.9-5-2.9-11 0-16l91-157.7z'
      
    ]
  };

  

  
  

  var faMagicBold = {
    prefix: 'fak',
    iconName: 'magic-bold',
    icon: [
      512,
      512,
      [],
      'e041',
      
      'M391.3 43.2c-2.9-6.2-11.6-6.2-14.5 0l-8.5 18.3c-9.5 20.4-26 36.9-46.4 46.4l-18.3 8.5c-6.2 2.9-6.2 11.6 0 14.5l18.3 8.5c20.4 9.5 36.9 26 46.4 46.4l8.5 18.3c2.9 6.2 11.6 6.2 14.5 0l8.5-18.3c9.5-20.4 26-36.9 46.4-46.4l18.3-8.5c6.2-2.9 6.2-11.6 0-14.5l-18.3-8.5c-20.4-9.5-36.9-26-46.4-46.4l-8.5-18.3zM238.5 122.8c-5.7-12.3-23.3-12.3-29 0l-17.1 36.6c-19.1 40.9-51.9 73.7-92.8 92.8L63.1 269.2c-12.3 5.7-12.3 23.3 0 29l36.6 17.1c40.9 19.1 73.7 51.9 92.8 92.8l17.1 36.6c5.7 12.3 23.3 12.3 29 0l17.1-36.6c19.1-40.9 51.9-73.7 92.8-92.8l36.6-17.1c12.3-5.7 12.3-23.3 0-29l-36.6-17.1c-40.9-19.1-73.7-51.9-92.8-92.8l-17.1-36.6z'
      
    ]
  };

  

  
  

  var faCampaign = {
    prefix: 'fak',
    iconName: 'campaign',
    icon: [
      512,
      512,
      [],
      'e007',
      
      'M352.6 58l61.3 297.4L288.3 287.1c-5.3-2.9-11.5-3.8-17.4-2.5l-24.1 5.3L225.7 187.5l24.8-5.4c5.8-1.3 11-4.6 14.6-9.3L352.6 58zm70.7 93.3c4 1.4 7.9 3.3 11.5 5.7c11.1 7.4 19.1 19.3 22 33.1c2.8 13.8 .2 28.2-7.1 39.9c-2.3 3.7-5 7-8.1 9.9l-18.2-88.5zm29.2 141.9c16.1-8.2 29.9-20.7 39.7-36.4c14.4-22.8 19.3-50.5 13.8-76.9c-5.5-26.5-20.9-49.8-43.3-64.8c-15.2-10.1-32.6-15.8-50.4-16.7L400.9 42.3c-1.8-8.9-6.1-17.1-12.4-23.8C382.2 11.9 374.1 7.2 365.1 5s-18.4-1.6-27.1 1.5s-16.2 8.7-21.7 16L230.6 134.8l-187.2 41c-13.3 2.9-24.6 11.1-31.7 22.4c-7.1 11.3-9.5 25-6.9 38L25.6 337.4c2.7 13 10.3 24.7 21.5 32.2c11.2 7.5 25 10.2 38.3 7.3l48.7-10.7L155 467.7c2.7 13 10.3 24.7 21.5 32.2c11.2 7.5 25 10.2 38.3 7.3l24.5-5.4c13.3-2.9 24.6-11.1 31.7-22.4c7.1-11.3 9.5-25 6.9-38l-21-102.1 15.6-3.4 122.4 66.6c8.1 4.4 17.3 6.4 26.5 5.6s17.9-4.2 25.2-9.9c7.2-5.6 12.6-13.2 15.7-21.7s3.7-17.8 1.9-26.6l-11.7-56.6zm-255 7.6L75.1 327.6c0-.1-.1-.2-.1-.3L54.1 226.1c0-.2 0-.4 0-.5s.1-.3 .1-.4c0 0 0 0 0-.1l122.1-26.8 21.1 102.4zm10.2 49.4l20.9 101.5c0 .2 0 .4 0 .5s-.1 .3-.1 .4c0 0 0 0 0 .1l-24 5.2c0-.1-.1-.2-.1-.3l-21-102.1 24.4-5.3z'
      
    ]
  };

  

  
  

  var faDesktop = {
    prefix: 'fak',
    iconName: 'desktop',
    icon: [
      512,
      512,
      [],
      'e00d',
      
      'M40 128c0-48.6 39.4-88 88-88l256 0c48.6 0 88 39.4 88 88l0 160c0 48.6-39.4 88-88 88l-40 0 0 48 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-256 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 0-48-40 0c-48.6 0-88-39.4-88-88l0-160zM296 424l0-48-80 0 0 48 80 0zm88-96c19.3 0 35.4-13.6 39.2-31.8l-334.3 0C92.6 314.4 108.7 328 128 328l256 0zM128 88c-22.1 0-40 17.9-40 40l0 120.2 336 0L424 128c0-22.1-17.9-40-40-40L128 88z'
      
    ]
  };

  

  
  

  var faCirclePlus = {
    prefix: 'fak',
    iconName: 'circle-plus',
    icon: [
      512,
      512,
      [],
      'e00f',
      
      'M256 136c13.3 0 24 10.7 24 24v72h72c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H160c-13.3 0-24-10.7-24-24s10.7-24 24-24h72V160c0-13.3 10.7-24 24-24zM32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm400 0A176 176 0 1 0 80 256a176 176 0 1 0 352 0z'
      
    ]
  };

  

  
  

  var faExit = {
    prefix: 'fak',
    iconName: 'exit',
    icon: [
      512,
      512,
      [],
      'e014',
      
      'M280 32c-19.1 0-37.4 7.6-50.9 21.1S208 84.9 208 104c0 6.4 2.5 12.5 7 17s10.6 7 17 7s12.5-2.5 17-7s7-10.6 7-17s2.5-12.5 7-17s10.6-7 17-7H408c6.4 0 12.5 2.5 17 7s7 10.6 7 17V408c0 6.4-2.5 12.5-7 17s-10.6 7-17 7H280c-6.4 0-12.5-2.5-17-7s-7-10.6-7-17s-2.5-12.5-7-17s-10.6-7-17-7s-12.5 2.5-17 7s-7 10.6-7 17c0 19.1 7.6 37.4 21.1 50.9S260.9 480 280 480H408c19.1 0 37.4-7.6 50.9-21.1S480 427.1 480 408V104c0-19.1-7.6-37.4-21.1-50.9S427.1 32 408 32H280zm16 248c6.4 0 12.5-2.5 17-7s7-10.6 7-17s-2.5-12.5-7-17s-10.6-7-17-7H113.9l31-31c4.2-4.5 6.5-10.6 6.4-16.8s-2.6-12.2-7-16.5s-10.3-6.9-16.5-7s-12.2 2.2-16.8 6.4L39 239c-4.5 4.5-7 10.6-7 17s2.5 12.5 7 17l72 72c4.5 4.2 10.6 6.5 16.8 6.4s12.2-2.6 16.5-7s6.9-10.3 7-16.5s-2.2-12.2-6.4-16.8l-31-31H296z'
      
    ]
  };

  

  
  

  var faCircleXBold = {
    prefix: 'fak',
    iconName: 'circle-x-bold',
    icon: [
      512,
      512,
      [],
      'e04d',
      
      'M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM359.4 175.7c0 6.4-2.5 12.5-7 17l-63 63 63 63c2.4 2.2 4.2 4.8 5.6 7.8s2 6.1 2.1 9.3s-.5 6.4-1.7 9.4s-3 5.7-5.3 8s-5 4.1-8 5.3s-6.2 1.8-9.4 1.7s-6.4-.8-9.3-2.1c-1.3-.6-2.5-1.2-3.6-2c-1.5-1-2.9-2.2-4.2-3.6l-63-63-63 63c-4.5 4.2-10.6 6.5-16.8 6.4s-12.2-2.6-16.5-7s-6.9-10.3-7-16.5s2.2-12.2 6.4-16.8l63-63-63-63c-4.2-4.5-6.5-10.6-6.4-16.8s2.6-12.1 7-16.5s10.3-6.9 16.5-7s12.2 2.2 16.8 6.4l63 63 63-63c4.5-4.5 10.6-7 17-7s12.5 2.5 17 7s7 10.6 7 17z'
      
    ]
  };

  

  
  

  var faPhoneMissed = {
    prefix: 'fak',
    iconName: 'phone-missed',
    icon: [
      512,
      512,
      [],
      'e059',
      
      'M227.5 67.1C221.9 39 196 19.7 167.4 22.2L96.9 28.7c-27 2.5-50.8 24.9-49.5 55c4.4 97.6 55.3 193.3 126.3 263.8c71 70.4 165 118.6 258.7 116.6c26.4-.6 45.9-20.5 50.5-43.6l12.2-61c6.1-30.4-13.6-59.9-44-66l-67-13.4c-18.4-3.7-37.4 2.1-50.7 15.3L323 305.9c-1.4 1.4-2.7 1.8-3.2 1.9l-.2 0c-15.6-10.2-36.7-28.4-57.1-48.8s-38.6-41.5-48.8-57.1l0-.2c.1-.6 .6-1.8 1.9-3.2l10.5-10.5c13.3-13.3 19-32.3 15.3-50.7L227.5 67.1zm-55.9 1.1c5-.5 9.6 3 10.6 7.9l14.1 70.3c.6 3.2-.4 6.6-2.7 8.9L183 165.9c-14.5 14.5-22.3 39.5-7.9 61.4c12.7 19.3 33.3 43 54.8 64.4s45.1 42.1 64.4 54.8c21.8 14.3 46.9 6.6 61.4-7.9l10.5-10.5c2.3-2.3 5.7-3.4 8.9-2.7l67 13.4c5.4 1.1 8.8 6.3 7.8 11.6l-12.2 61c-.9 4.7-4.2 6.4-6.2 6.5c-77.6 1.7-160.2-38.7-225.2-103.2C141.5 250.3 97.3 165 93.6 81.6c-.1-1.5 .4-2.9 1.6-4.2c1.3-1.4 3.3-2.5 5.9-2.7l70.5-6.4zM464.8 49.7c9.4 9.4 9.4 24.6 0 33.9L436.6 112l28.3 28.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-28.3-28.3-28.3 28.3c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L368.7 112 340.4 83.7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L402.6 78l28.3-28.3c9.4-9.4 24.6-9.4 33.9 0z'
      
    ]
  };

  

  
  

  var faSad = {
    prefix: 'fak',
    iconName: 'sad',
    icon: [
      512,
      512,
      [],
      'e068',
      
      'M256 294.4c-23 0-44.7 5-65 15s-36.6 24.6-49 43.8c-4.7 6.8-5.3 13.7-1.9 20.5s9 10.2 16.6 10.2c3.4 0 6.5-.7 9.3-2.2s5.2-3.7 7.4-6.7c9.8-13.2 22-23.6 36.5-31s29.9-11.2 46.1-11.2s31.6 3.7 46.1 11.2s26.7 17.8 36.5 31c1.7 3 3.9 5.2 6.7 6.7s5.9 2.2 9.3 2.2c7.7 0 13.2-3.5 16.6-10.6s2.8-14.2-1.9-21.4c-12.4-18.8-28.7-33.1-49-42.9s-41.7-14.7-64.3-14.7zm89.6-64a38.4 38.4 0 1 0 0-76.8 38.4 38.4 0 1 0 0 76.8zm-179.2 0a38.4 38.4 0 1 0 0-76.8 38.4 38.4 0 1 0 0 76.8zM256 512c-35.4 0-68.7-6.7-99.8-20.2s-58.2-31.7-81.3-54.7s-41.3-50.1-54.7-81.3S0 291.4 0 256s6.7-68.7 20.2-99.8S51.8 97.9 74.9 74.9s50.1-41.3 81.3-54.7S220.6 0 256 0s68.7 6.7 99.8 20.2s58.2 31.7 81.3 54.7s41.3 50.1 54.7 81.3S512 220.6 512 256s-6.7 68.7-20.2 99.8s-31.7 58.2-54.7 81.3s-50.1 41.3-81.3 54.7S291.4 512 256 512zm0-51.2c57.2 0 105.6-19.8 145.3-59.5s59.5-88.1 59.5-145.3s-19.8-105.6-59.5-145.3S313.2 51.2 256 51.2s-105.6 19.8-145.3 59.5S51.2 198.8 51.2 256s19.8 105.6 59.5 145.3s88.1 59.5 145.3 59.5z'
      
    ]
  };

  

  
  

  var faDownChevron = {
    prefix: 'fak',
    iconName: 'down-chevron',
    icon: [
      512,
      512,
      [],
      'e013',
      
      'M464.3 186.2c9.8-9.8 9.8-25.8 0-35.6s-25.8-9.8-35.6 0L256 323.2 83.4 150.5c-9.8-9.8-25.8-9.8-35.6 0s-9.8 25.8 0 35.6L238.2 376.6v0c1.2 1.2 2.6 2.3 4 3.2c9.8 6.5 23.1 5.4 31.7-3.2v0L464.3 186.2z'
      
    ]
  };

  

  
  

  var faFast = {
    prefix: 'fak',
    iconName: 'fast',
    icon: [
      512,
      512,
      [],
      'e019',
      
      'M331.3 10.7c10.1 5.1 15.5 16.3 13.3 27.4L310.1 210.5l70.6 0c10 0 19 5.9 23.1 15.1s2.3 19.8-4.5 27.2L176.4 495.9c-7.6 8.3-19.9 10.6-30 5.4s-15.5-16.3-13.3-27.4l34.5-172.4-70.6 0c-10 0-19-5.9-23.1-15.1s-2.3-19.8 4.5-27.2L301.3 16.1c7.6-8.3 19.9-10.6 30-5.4zm-177 240.4l44 0c7.5 0 14.7 3.4 19.5 9.2s6.7 13.5 5.2 20.9L200.2 395.3 323.4 260.9l-44 0c-7.5 0-14.7-3.4-19.5-9.2s-6.7-13.5-5.2-20.9l22.8-114.1L154.3 251.1z'
      
    ]
  };

  

  
  

  var faCircleLine = {
    prefix: 'fak',
    iconName: 'circle-line',
    icon: [
      512,
      512,
      [],
      'e018',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zM362.3 396.3L115.7 149.7C93.3 179.2 80 216.1 80 256c0 97.2 78.8 176 176 176c39.9 0 76.8-13.3 106.3-35.7zm33.9-33.9C418.7 332.8 432 295.9 432 256c0-97.2-78.8-176-176-176c-39.9 0-76.8 13.3-106.3 35.7L396.3 362.3z'
      
    ]
  };

  

  
  

  var faNavCampaigns = {
    prefix: 'fak',
    iconName: 'nav-campaigns',
    icon: [
      512,
      512,
      [],
      'e05e',
      
      'M450.7 96.2c6.8 2 8.8 10.2 4.5 15.9c-8.2 10.9-19.1 27.5-19.6 38.5c-.6 13.7 38.5-10.4 35.2 7.9c-4.1 22.3-22.1 43.9-42.3 55.6c-30.6 17.7-69.8 7.2-87.4-23.4s-7.2-69.8 23.4-87.4c32-18.5 67.4-12.4 86.2-7zM207.5 113.5c4.5-3.6 10-5.7 15.7-6.2s11.4 .7 16.5 3.4s9.2 6.7 12 11.6L355 301.1c2.8 4.9 4.3 10.5 4.1 16.2s-1.9 11.2-5 16s-7.7 8.5-12.9 10.8s-11.1 2.9-16.8 1.9l-90.8-16.3-23.7 14.1 39.6 68.5c4.2 7.2 5.4 15.8 3.4 23.9c-2 8.1-7.1 15.2-14.4 19.5l-14.2 8.4c-7.3 4.3-16 5.5-24.1 3.2c-8.1-2.2-15-7.6-19.1-14.8l-39.4-68.1-16.8 10c-7.3 4.3-16 5.5-24.1 3.2c-8.1-2.2-15-7.6-19.1-14.8l-34-58.8c-4.2-7.2-5.4-15.8-3.4-23.9c2-8.1 7.1-15.2 14.4-19.5l108.8-64.7 30.4-88.4c1.9-5.4 5.2-10.2 9.7-13.7z'
      
    ]
  };

  

  
  

  var faPlus = {
    prefix: 'fak',
    iconName: 'plus',
    icon: [
      512,
      512,
      [],
      'e02c',
      
      'M280 56.4c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H56.4c-13.3 0-24 10.7-24 24s10.7 24 24 24H232V455.6c0 13.3 10.7 24 24 24s24-10.7 24-24V280H455.6c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V56.4z'
      
    ]
  };

  

  
  

  var faGrip = {
    prefix: 'fak',
    iconName: 'grip',
    icon: [
      512,
      512,
      [],
      'e01e',
      
      'M140.8 102.5a38.4 38.4 0 1 0 76.8 0 38.4 38.4 0 1 0 -76.8 0zm38.4 115.1a38.4 38.4 0 1 1 0 76.8 38.4 38.4 0 1 1 0-76.8zm-38.4 192a38.4 38.4 0 1 0 76.8 0 38.4 38.4 0 1 0 -76.8 0zM294.4 102.5a38.4 38.4 0 1 0 76.8 0 38.4 38.4 0 1 0 -76.8 0zm38.4 115.1a38.4 38.4 0 1 1 0 76.8 38.4 38.4 0 1 1 0-76.8zm-38.4 192a38.4 38.4 0 1 0 76.8 0 38.4 38.4 0 1 0 -76.8 0z'
      
    ]
  };

  

  
  

  var faCopy = {
    prefix: 'fak',
    iconName: 'copy',
    icon: [
      512,
      512,
      [],
      'e00c',
      
      'M77.2 77.2c3.3-3.3 7.8-5.2 12.4-5.2H276.8c4.7 0 9.1 1.9 12.4 5.2s5.2 7.8 5.2 12.4v20.8c0 13.3 10.7 24 24 24s24-10.7 24-24V89.6c0-17.4-6.9-34.1-19.2-46.4S294.2 24 276.8 24H89.6c-17.4 0-34.1 6.9-46.4 19.2S24 72.2 24 89.6V276.8c0 17.4 6.9 34.1 19.2 46.4s29 19.2 46.4 19.2h20.8c13.3 0 24-10.7 24-24s-10.7-24-24-24H89.6c-4.7 0-9.1-1.9-12.4-5.2s-5.2-7.8-5.2-12.4V89.6c0-4.7 1.9-9.1 5.2-12.4zm158 92.4c-36.2 0-65.6 29.4-65.6 65.6l0 187.2c0 36.2 29.4 65.6 65.6 65.6l187.2 0c36.2 0 65.6-29.4 65.6-65.6l0-187.2c0-36.2-29.4-65.6-65.6-65.6l-187.2 0zm-17.6 65.6c0-9.7 7.9-17.6 17.6-17.6l187.2 0c9.7 0 17.6 7.9 17.6 17.6l0 187.2c0 9.7-7.9 17.6-17.6 17.6l-187.2 0c-9.7 0-17.6-7.9-17.6-17.6l0-187.2z'
      
    ]
  };

  

  
  

  var faStarBold = {
    prefix: 'fak',
    iconName: 'star-bold',
    icon: [
      543,
      512,
      [],
      'e03d',
      
      'M297.4 17.2c-10.3-21.9-41.5-21.9-51.8 0L186.4 143.3 53.9 163.5c-23 3.5-32.4 31.6-16.2 48.3l96.9 99.1L111.8 450.8C108 474.4 133 492 153.9 480.5l117.7-65.1 117.4 65.1c20.9 11.6 46-6 42.1-29.6L408.4 310.9l96.9-99.1c16.3-16.7 6.9-44.8-16.2-48.3L356.6 143.3 297.4 17.2z'
      
    ]
  };

  

  
  

  var faArrowUp = {
    prefix: 'fak',
    iconName: 'arrow-up',
    icon: [
      512,
      512,
      [],
      'e004',
      
      'M374.8 209.5c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L273 39.8c-9.4-9.4-24.6-9.4-33.9 0L103.3 175.6c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L232 114.7 232 448c0 13.3 10.7 24 24 24s24-10.7 24-24l0-333.3 94.8 94.8z'
      
    ]
  };

  

  
  

  var faGenerate = {
    prefix: 'fak',
    iconName: 'generate',
    icon: [
      512,
      512,
      [],
      'e01d',
      
      'M87.5 22.3c4.2-7 13-7 17.2 0l24.1 39.9c1.1 1.8 2.6 3.2 4.3 4.1l36.8 19.4c8.3 4.4 8.3 18.3 0 22.7l-36.8 19.4c-1.7 .9-3.2 2.3-4.3 4.1l-24.1 39.9c-4.2 7-13 7-17.2 0L63.5 132c-1.1-1.8-2.6-3.2-4.3-4.1L22.4 108.4c-8.3-4.4-8.3-18.3 0-22.7L59.2 66.4c1.7-.9 3.2-2.3 4.3-4.1L87.5 22.3zm305.1 41c-15-15-39.3-15-54.3 0L81.1 320.5c-4.8 4.8-8.3 10.8-10 17.4L50.9 414.6C43.5 443 69.4 469 97.8 461.5l76.8-20.2c6.6-1.7 12.6-5.2 17.4-10L449.2 174.2c15-15 15-39.3 0-54.3L392.6 63.3zm-73.3 82.4l46.2-46.2L413 147l-46.2 46.2-47.5-47.5zm-33.9 33.9l47.5 47.5L161.5 398.4l-64.5 17 17-64.5L285.3 179.6zM425.4 341.9c-4.2-7-13-7-17.2 0l-24.1 39.9c-1.1 1.8-2.6 3.2-4.3 4.1L343 405.3c-8.3 4.4-8.3 18.3 0 22.7l36.8 19.4c1.7 .9 3.2 2.3 4.3 4.1l24.1 39.9c4.2 7 13 7 17.2 0l24.1-39.9c1.1-1.8 2.6-3.2 4.3-4.1L490.5 428c8.3-4.4 8.3-18.3 0-22.7l-36.8-19.4c-1.7-.9-3.2-2.3-4.3-4.1l-24.1-39.9z'
      
    ]
  };

  

  
  

  var faPlayBold = {
    prefix: 'fak',
    iconName: 'play-bold',
    icon: [
      512,
      512,
      [],
      'e03f',
      
      'M447.6 228.3c21.3 12.3 21.3 43.1 0 55.4l-320 184.6c-21.3 12.3-48-3.1-48-27.7l0-369.2c0-24.6 26.7-40 48-27.7l320 184.6z'
      
    ]
  };

  

  
  

  var faEmail = {
    prefix: 'fak',
    iconName: 'email',
    icon: [
      512,
      512,
      [],
      'e00e',
      
      'M64 80C33.1 80 8 105.1 8 136L8 376c0 30.9 25.1 56 56 56l384 0c30.9 0 56-25.1 56-56l0-240c0-30.9-25.1-56-56-56L64 80zm-8 71.8L223.7 270.5c19.3 13.7 45.2 13.7 64.6 .1L456 152.6 456 376c0 4.4-3.6 8-8 8L64 384c-4.4 0-8-3.6-8-8l0-224.2zM407.5 128L260.7 231.4c-2.8 1.9-6.5 1.9-9.2 0L105.4 128l302.1 0z'
      
    ]
  };

  

  
  

  var faPlay = {
    prefix: 'fak',
    iconName: 'play',
    icon: [
      512,
      512,
      [],
      'e03e',
      
      'M399.6 256L127.7 412.9l0-313.8L399.6 256zm48 27.7c21.3-12.3 21.3-43.1 0-55.4L127.7 43.7c-21.3-12.3-48 3.1-48 27.7l0 369.2c0 24.6 26.7 40 48 27.7l320-184.6z'
      
    ]
  };

  

  
  

  var faLink = {
    prefix: 'fak',
    iconName: 'link',
    icon: [
      512,
      512,
      [],
      'e06c',
      
      'M128 384c-35.4 0-65.6-12.5-90.6-37.4S0 291.4 0 256s12.5-65.6 37.4-90.6s55.1-37.4 90.6-37.4h76.8c7.3 0 13.3 2.5 18.2 7.4s7.4 11 7.4 18.2s-2.5 13.3-7.4 18.2s-11 7.4-18.2 7.4H128c-21.3 0-39.5 7.5-54.4 22.4S51.2 234.7 51.2 256s7.5 39.5 22.4 54.4s33.1 22.4 54.4 22.4h76.8c7.3 0 13.3 2.5 18.2 7.4s7.4 11 7.4 18.2s-2.5 13.3-7.4 18.2s-11 7.4-18.2 7.4H128zm51.2-102.4c-7.3 0-13.3-2.5-18.2-7.4s-7.4-11-7.4-18.2s2.5-13.3 7.4-18.2s11-7.4 18.2-7.4H332.8c7.3 0 13.3 2.5 18.2 7.4s7.4 11 7.4 18.2s-2.5 13.3-7.4 18.2s-11 7.4-18.2 7.4H179.2zM307.2 384c-7.3 0-13.3-2.5-18.2-7.4s-7.4-11-7.4-18.2s2.5-13.3 7.4-18.2s11-7.4 18.2-7.4H384c21.3 0 39.5-7.5 54.4-22.4s22.4-33.1 22.4-54.4s-7.5-39.5-22.4-54.4s-33.1-22.4-54.4-22.4H307.2c-7.3 0-13.3-2.5-18.2-7.4s-7.4-11-7.4-18.2s2.5-13.3 7.4-18.2s11-7.4 18.2-7.4H384c35.4 0 65.6 12.5 90.6 37.4s37.4 55.1 37.4 90.6s-12.5 65.6-37.4 90.6s-55.1 37.4-90.6 37.4H307.2z'
      
    ]
  };

  

  
  

  var faCompany = {
    prefix: 'fak',
    iconName: 'company',
    icon: [
      512,
      512,
      [],
      'e017',
      
      'M351.9 432l80.1 0 0-176c0-8.8-7.2-16-16-16l-64.1 0 0 192zm-87.1 0l39.1 0 0-240.2 .1 0L304 96c0-8.8-7.2-16-16-16L96 80c-8.8 0-16 7.2-16 16l0 336 40.8 0 0-104.8c0-4.4 3.6-8 8-8l128 0c4.4 0 8 3.6 8 8l0 104.8zM416 192c35.3 0 64 28.7 64 64l0 192c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 96c0-35.3 28.7-64 64-64l192 0c35.3 0 64 28.7 64 64l0 96 64 0zM128.8 130.3l32 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-32c0-4.4 3.6-8 8-8zm-8 102.4c0-4.4 3.6-8 8-8l32 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-32zm104-102.4l32 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-32c0-4.4 3.6-8 8-8zm-8 102.4c0-4.4 3.6-8 8-8l32 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-32zm-48 198.4l48 0 0-64-48 0 0 64z'
      
    ]
  };

  

  
  

  var faInfoBold = {
    prefix: 'fak',
    iconName: 'info-bold',
    icon: [
      482,
      512,
      [],
      'e048',
      
      'M241 507.8A240.9 240.9 0 1 0 241 26a240.9 240.9 0 1 0 0 481.9zM218.4 169.4a22.6 22.6 0 1 1 45.2 0 22.6 22.6 0 1 1 -45.2 0zm45.2 82.8l0 120.5c0 12.5-10.1 22.6-22.6 22.6s-22.6-10.1-22.6-22.6l0-120.5c0-12.5 10.1-22.6 22.6-22.6s22.6 10.1 22.6 22.6z'
      
    ]
  };

  

  
  

  var faArrowDown = {
    prefix: 'fak',
    iconName: 'arrow-down',
    icon: [
      512,
      512,
      [],
      'e003',
      
      'M137.2 295.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 465c9.4 9.4 24.6 9.4 33.9 0L408.7 329.2c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L280 390.1l0-333.3c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 333.3-94.8-94.8z'
      
    ]
  };

  

  
  

  var faSent = {
    prefix: 'fak',
    iconName: 'sent',
    icon: [
      512,
      512,
      [],
      'e02f',
      
      'M496.7 45.7c3.1-8.6 1-18.3-5.5-24.8s-16.2-8.7-24.8-5.5L66.8 159.6c-.6 .2-1.2 .5-1.8 .7c-6.3 2.9-11.6 7.5-15.3 13.3S44 186.1 44 193s2 13.6 5.7 19.4c3.6 5.6 8.8 10.2 14.8 13l148 74 74 148c2.9 6.1 7.4 11.2 13 14.8c5.8 3.7 12.5 5.7 19.4 5.7s13.6-2 19.4-5.7s10.4-9 13.3-15.3c.3-.6 .5-1.2 .7-1.8L496.7 45.7zM317.3 402.8L259.1 286.4 415.9 129.6 317.3 402.8zM109.2 194.7L382.4 96.1 225.6 252.9 109.2 194.7zm55.3 186c8.8-8.8 8.8-23.1 0-31.9s-23.1-8.8-31.9 0L42.2 439.1c-8.8 8.8-8.8 23.1 0 31.9s23.1 8.8 31.9 0l90.4-90.4zm-51.7-83.6c8.8 8.8 8.8 23.1 0 31.9L67.6 374.2c-8.8 8.8-23.1 8.8-31.9 0s-8.8-23.1 0-31.9l45.2-45.2c8.8-8.8 23.1-8.8 31.9 0zM216.3 432.5c8.8-8.8 8.8-23.1 0-31.9s-23.1-8.8-31.9 0l-45.2 45.2c-8.8 8.8-8.8 23.1 0 31.9s23.1 8.8 31.9 0l45.2-45.2z'
      
    ]
  };

  

  
  

  var faHintBold = {
    prefix: 'fak',
    iconName: 'hint-bold',
    icon: [
      512,
      512,
      [],
      'e04a',
      
      'M256 33.7c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24zM97.9 262.3c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0c13.3 0 24 10.7 24 24zm379.7 0c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0c13.3 0 24 10.7 24 24zM90.4 102.6c9.6-9.2 24.8-8.9 33.9 .7l11.2 11.6c9.2 9.6 8.9 24.8-.7 33.9s-24.8 8.9-33.9-.7L89.7 136.5c-9.2-9.6-8.9-24.8 .7-33.9zm331 .9c9.4 9.4 9.4 24.6 0 33.9l-11.1 11.1c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l11.1-11.1c9.4-9.4 24.6-9.4 33.9 0zM127.8 262.6c0-70.7 57.3-128 128-128s128 57.3 128 128c0 25-3.6 44.4-9.8 60.2c-6.3 16-14.7 26.9-22.3 35.4c-2.9 3.3-5.2 5.8-7.2 7.9c-.2 .3-.5 .5-.7 .8l-176 0-.7-.8c-2-2.1-4.3-4.6-7.2-7.9c-7.6-8.5-16-19.4-22.3-35.4c-6.2-15.8-9.8-35.1-9.8-60.2zm52 144.2l152 0 0 37.8c0 20.4-16.6 37-37 37l-78 0c-20.4 0-37-16.6-37-37l0-37.8z'
      
    ]
  };

  

  
  

  var faAppleLogo = {
    prefix: 'fak',
    iconName: 'apple-logo',
    icon: [
      512,
      512,
      [],
      'e06a',
      
      'M358.5 512h-8.6c-.5-.1-.9-.3-1.4-.4c-2.1-.4-4.3-.7-6.4-1.1c-9.6-1.9-18.8-5-27.9-8.6c-9.4-3.7-18.8-7.2-28.7-9.4c-9.2-2.1-18.5-2.9-27.8-2.2c-8 .7-15.9 2.3-23.6 4.7c-9.8 2.9-19.3 6.7-28.7 10.6c-5.9 2.4-12.1 4.2-18.4 5.2c-2.3 .4-4.7 .8-7 1.2h-9.4c-1.7-.4-3.3-.7-5-1.1c-6.9-1.4-13.2-4.2-19.2-7.7c-11.3-6.7-20.8-15.4-29.6-25c-11.3-12.2-21.2-25.5-30.4-39.3c-16.4-24.7-29.3-51-38.1-79.4c-4.5-14.4-7.8-29.1-9.9-44c-1.3-9.1-2.2-18.1-2.6-27.3c-.1-1.9-.5-3.8-.7-5.6c0-7 0-13.9 0-20.9c.2-1.5 .6-3.1 .7-4.6c.7-10.8 2.1-21.6 4.6-32.2c5.4-23.1 15.2-44 30.6-62.2c17-20 38.1-33.7 63.4-40.6c9.3-2.5 18.8-4 28.4-4.7c8.4-.6 16.8-.6 25.2 .2c10.4 1 20.5 3.5 30.3 7.4c8.7 3.5 17.4 7.1 26.1 10.6c8.4 3.3 17 4.3 25.9 2.4c5.3-1.2 10.5-2.8 15.6-4.8c8.5-3.3 17-6.7 25.7-9.5c11.9-3.9 24.2-5.7 36.8-6.3c12.9-.6 25.6 .1 38.3 2.5c12.1 2.3 23.7 6.3 34.6 12c14.3 7.5 26.6 17.5 37.3 29.6c1.7 2 3.4 4 5.2 6.1c-.7 .6-1.3 1-1.9 1.5c-3.7 2.8-7.4 5.6-11 8.6c-11 9.1-20.6 19.5-28.4 31.5c-10.6 16.5-16.3 34.6-16.9 54.2c-.2 8.9 .5 17.8 2.2 26.7c3.9 19.7 12.9 36.7 26.4 51.3c10.3 11.1 22.3 20 35.5 27.5c2.4 1.4 4.9 2.7 7.5 4.1c-.2 .7-.3 1.4-.5 2.1c-.8 2.3-1.6 4.6-2.5 6.9c-13 34.3-31.5 65.3-56.3 92.4c-8.7 9.4-18 18.1-28.7 25.2c-7.9 5.3-16.3 9.4-25.7 11.2c-1.6 .3-3.2 .7-4.8 1l0 0zM253.2 123.7c-.2-1.7-.5-3.2-.7-4.8c-1.9-15.4 .4-30.2 6.3-44.5c5-12.3 12.4-23.2 21.1-33.2c9.6-11 20.5-20.3 33.3-27.5c10.5-6 21.8-10 33.7-12.1c3.4-.6 6.9-1.1 10.3-1.6c.5-.1 1.1 0 1.7 0c.2 1.3 .3 2.5 .4 3.7c2.5 31-6.5 58.3-27 81.8c-8.4 9.6-17.9 18-28.9 24.5c-10.8 6.4-22.4 10.8-35 12.5c-4.3 .6-8.7 .8-13 1.2c-.7 .1-1.3 0-2.2 0v0z'
      
    ]
  };

  

  
  

  var faCircleX = {
    prefix: 'fak',
    iconName: 'circle-x',
    icon: [
      512,
      512,
      [],
      'e04c',
      
      'M360 175.7c0-6.4-2.5-12.5-7-17s-10.6-7-17-7s-12.5 2.5-17 7l-63 63-63-63c-4.5-4.2-10.6-6.5-16.8-6.4s-12.2 2.6-16.5 7s-6.9 10.3-7 16.5s2.2 12.2 6.4 16.8l63 63-63 63c-4.2 4.5-6.5 10.6-6.4 16.8s2.6 12.2 7 16.5s10.3 6.9 16.5 7s12.2-2.2 16.8-6.4l63-63 63 63c2.2 2.4 4.8 4.2 7.8 5.6s6.1 2 9.3 2.1s6.4-.5 9.4-1.7s5.7-3 8-5.3s4.1-5 5.3-8s1.8-6.2 1.7-9.4s-.8-6.4-2.1-9.3s-3.2-5.6-5.6-7.8l-63-63 63-63c4.5-4.5 7-10.6 7-17zM170.3 49A224 224 0 1 1 341.7 463 224 224 0 1 1 170.3 49zM380.5 380.5A176 176 0 1 0 131.5 131.5 176 176 0 1 0 380.5 380.5z'
      
    ]
  };

  

  
  

  var faCar = {
    prefix: 'fak',
    iconName: 'car',
    icon: [
      512,
      512,
      [],
      'e009',
      
      'M81.8 191.9l-8.3 38.8c-24.1 9.2-41.3 32.5-41.3 59.9l0 74.9c0 17.7 14.3 32 32 32l-.1 0 0 32c0 17.7 14.3 32 32 32l16.9 0c17.7 0 32-14.3 32-32l0-32 224.7 0 0 32c0 17.7 14.3 32 32 32l14.3 0c17.7 0 32-14.3 32-32l0-32c17.7 0 32-14.3 32-32l0-74.9c0-27.4-17.2-50.7-41.3-59.9l-8.3-38.8 25.8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-36.1 0-9.2-42.8c-6.3-29.5-32.4-50.6-62.6-50.6l-184.5 0c-30.2 0-56.3 21.1-62.6 50.6L92 143.9l-35.9 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l25.6 0zM348.3 98.5c7.5 0 14.1 5.3 15.6 12.6l24.7 115.3-265.2 0 24.7-115.3c1.6-7.4 8.1-12.7 15.6-12.7l184.5 0zM145 312a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm256.7 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faCircleDollar = {
    prefix: 'fak',
    iconName: 'circle-dollar',
    icon: [
      512,
      512,
      [],
      'e00b',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM333.9 145.4c11.9 5.9 16.7 20.3 10.7 32.2s-20.3 16.7-32.2 10.7c0 0 0 0 0 0c-.1 0-.6-.3-1.8-.7c-1.2-.4-2.9-.9-4.9-1.3c-4.1-.9-9.4-1.8-15.4-2.4c-12.2-1.3-26.4-1.4-39.7 .2c-13.7 1.7-24.2 5.1-30.7 9.4c-5.4 3.6-7.1 6.9-7.1 12c0 2.4 .3 5.4 9 10.4c9 5.2 21.3 9.1 37.3 14.2c0 0 0 0 0 0l4.3 1.4c16.3 5.2 36.6 12 52.6 23.1c17.4 12.2 31.3 30.7 31.3 57.8c0 25.1-10.7 44.3-28.4 56.2c-11.8 7.9-25.5 11.9-38.8 13.8l0 29c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-29.6c-6.2-.8-12.1-1.9-17.6-3c-14.5-3-28-7.2-36.3-11.3c-11.9-5.9-16.7-20.3-10.7-32.2s20.3-16.7 32.2-10.7c2.9 1.5 11.8 4.6 24.6 7.3c12.4 2.6 26.5 4.3 39.4 3.8c13.4-.5 22.9-3.1 28.4-6.8c3.9-2.6 7.3-6.6 7.3-16.4c0-7.9-3-13-10.7-18.4c-9.2-6.4-22.5-11.2-39.8-16.8c-1.6-.5-3.3-1-4.9-1.6c-14.6-4.7-32.1-10.2-45.9-18.2c-16.5-9.5-33-25.6-33-52c0-23.8 12.3-41.1 28.6-52c11.6-7.7 25.2-12.3 38.6-15l0-38c0-13.3 10.7-24 24-24s24 10.7 24 24l0 34.5c5.3 .2 10.4 .6 15.2 1.1c14.2 1.5 29 4.4 38.7 9.2z'
      
    ]
  };

  

  
  

  var faGoal = {
    prefix: 'fak',
    iconName: 'goal',
    icon: [
      482,
      512,
      [],
      'e057',
      
      'M437.6 150.6l.1-.1c6.7-6.7 4.4-18-4.4-21.6L431 128c-.7-.4-1.5-.8-2.4-1.2l-42.7-17.2L369 67.3c-.2-.6-.5-1.2-.8-1.8l-1.2-3c-3.5-8.8-14.8-11.1-21.6-4.4l-.3 .3c-1.5 .8-2.9 1.8-4.2 3.1l-45.1 45.1c-4.4 4.4-6.1 10.8-4.4 16.7l10.7 38.5L225 238.9c-8.8 8.8-8.8 23.1 0 31.9s23.1 8.8 31.9 0l77.1-77.1 38.5 10.7c6 1.7 12.4 0 16.7-4.4l45.1-45.1c1.3-1.3 2.4-2.8 3.2-4.3zM338.7 221l-69.9 69.9c-15.3 15.3-42.1 13.3-59.8-4.5s-19.8-44.5-4.5-59.8l70.3-70.3-5-30.1c-9.3-2.1-18.9-3.1-28.7-3.1c-72.8 0-131.8 59-131.8 131.8s59 131.8 131.8 131.8s131.8-59 131.8-131.8c0-9.9-1.1-19.4-3.1-28.7l-31-5.1zm69.4-3.8c2.7 12.1 4.1 24.7 4.1 37.6c0 94.6-76.7 171.3-171.3 171.3s-171.2-76.7-171.2-171.3s76.7-171.3 171.3-171.3c12.9 0 25.5 1.4 37.6 4.1l32-32c-21.8-7.6-45.2-11.7-69.6-11.7c-116.4 0-210.8 94.4-210.8 210.8s94.4 210.8 210.8 210.8s210.8-94.4 210.8-210.8c0-24.4-4.1-47.8-11.8-69.6l-31.9 32c0 0-.1 0-.1 0z'
      
    ]
  };

  

  
  

  var faMobile = {
    prefix: 'fak',
    iconName: 'mobile',
    icon: [
      512,
      512,
      [],
      'e024',
      
      'M216 352c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H216zM96 96c0-35.3 28.7-64 64-64l192 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64L96 96zm64-16c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L160 80z'
      
    ]
  };

  

  
  

  var faLockBold = {
    prefix: 'fak',
    iconName: 'lock-bold',
    icon: [
      512,
      512,
      [],
      'e03c',
      
      'M256 80.4c37.8 0 68.5 30.7 68.5 68.5c0 3.5-.3 6.9-.8 10.2l-135.5 0c-.5-3.3-.8-6.8-.8-10.2c0-37.8 30.7-68.5 68.5-68.5zM139.5 148.9c0 4.7 .3 9.3 .8 13.9c-44.2 12-76.7 52.4-76.7 100.4l0 113.5c0 57.4 46.6 104 104 104l176.7 0c57.4 0 104-46.6 104-104l0-113.5c0-48-32.5-88.4-76.7-100.4c.5-4.6 .8-9.2 .8-13.9c0-64.3-52.2-116.5-116.5-116.5s-116.5 52.2-116.5 116.5zM280 287.9l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64c0-13.3 10.7-24 24-24s24 10.7 24 24z'
      
    ]
  };

  

  
  

  var faCalendarMagic = {
    prefix: 'fak',
    iconName: 'calendar-magic',
    icon: [
      512,
      512,
      [],
      'e05a',
      
      'M367.3 55.5c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 9.1-127 0 0-9.1c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 9.1-32.3 0c-35.3 0-64 28.7-64 64l0 288c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64l-32.7 0 0-9.1zm-46.7 57.1c3.2 9.5 12.2 16.3 22.7 16.3s19.5-6.8 22.7-16.3l34 0c8.8 0 16 7.2 16 16l0 30.9-320 0 0-30.9c0-8.8 7.2-16 16-16l33.6 0c3.2 9.5 12.2 16.3 22.7 16.3s19.5-6.8 22.7-16.3l129.5 0zM96 207.4l320 0 0 209.1c0 8.8-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16l0-209.1zm152.8 32c2.9-6.2 11.6-6.2 14.5 0l8.5 18.3c9.5 20.4 26 36.9 46.4 46.4l18.3 8.5c6.2 2.9 6.2 11.6 0 14.5l-18.3 8.5c-20.4 9.5-36.9 26-46.4 46.4l-8.5 18.3c-2.9 6.2-11.6 6.2-14.5 0l-8.5-18.3c-9.5-20.4-26-36.9-46.4-46.4l-18.3-8.5c-6.2-2.9-6.2-11.6 0-14.5l18.3-8.5c20.4-9.5 36.9-26 46.4-46.4l8.5-18.3z'
      
    ]
  };

  

  
  

  var faLeftChevron = {
    prefix: 'fak',
    iconName: 'left-chevron',
    icon: [
      512,
      512,
      [],
      'e01f',
      
      'M321.1 463.9c9.8 9.8 25.8 9.8 35.6 0s9.8-25.8 0-35.6L184.1 255.7 356.7 83c9.8-9.8 9.8-25.8 0-35.6s-25.8-9.8-35.6 0L130.7 237.8v0c-1.2 1.2-2.3 2.6-3.2 4c-6.5 9.8-5.4 23.1 3.2 31.7v0L321.1 463.9z'
      
    ]
  };

  

  
  

  var faSearch = {
    prefix: 'fak',
    iconName: 'search',
    icon: [
      512,
      512,
      [],
      'e036',
      
      'M205.6 54.4a151.2 151.2 0 1 0 0 302.5 151.2 151.2 0 1 0 0-302.5zM4 205.6C4 94.2 94.2 4 205.6 4S407.2 94.2 407.2 205.6c0 46.6-15.8 89.5-42.3 123.6L500.7 465c9.8 9.8 9.8 25.8 0 35.6s-25.8 9.8-35.6 0L329.2 364.9c-34.1 26.5-77 42.3-123.6 42.3C94.2 407.2 4 316.9 4 205.6z'
      
    ]
  };

  

  
  

  var faEdit = {
    prefix: 'fak',
    iconName: 'edit',
    icon: [
      512,
      512,
      [],
      'e011',
      
      'M392.6 63.3c-15-15-39.3-15-54.3 0L81.1 320.5c-4.8 4.8-8.3 10.8-10 17.4L50.9 414.6C43.5 443 69.4 469 97.8 461.5l76.8-20.2c6.6-1.7 12.6-5.2 17.4-10L449.2 174.2c15-15 15-39.3 0-54.3L392.6 63.3zm-73.3 82.4l46.2-46.2L413 147l-46.2 46.2-47.5-47.5zm-33.9 33.9l47.5 47.5L161.5 398.4l-64.5 17 17-64.5L285.3 179.6z'
      
    ]
  };

  

  
  

  var faArrowLink = {
    prefix: 'fak',
    iconName: 'arrow-link',
    icon: [
      512,
      512,
      [],
      'e002',
      
      'M282.1 46.1c0-13.3 10.7-24 24-24H465.9c13.3 0 24 10.7 24 24V206c0 13.3-10.7 24-24 24s-24-10.7-24-24V104L285.3 260.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L408 70.1H306.1c-13.3 0-24-10.7-24-24zM74.3 149.4c0-24 19.5-43.5 43.5-43.5h53.1c14.4 0 26.1-11.7 26.1-26.1s-11.7-26.1-26.1-26.1H117.8c-52.9 0-95.8 42.9-95.8 95.8V394.1c0 52.9 42.9 95.8 95.8 95.8H362.5c52.9 0 95.8-42.9 95.8-95.8V342.8c0-14.4-11.7-26.1-26.1-26.1s-26.1 11.7-26.1 26.1v51.4c0 24-19.5 43.5-43.5 43.5H117.8c-24 0-43.5-19.5-43.5-43.5V149.4z'
      
    ]
  };

  

  
  

  var faNavInbox = {
    prefix: 'fak',
    iconName: 'nav-inbox',
    icon: [
      512,
      512,
      [],
      'e060',
      
      'M85.3 64c-23.6 0-42.7 19.1-42.7 42.7V210.5c0 23.6 19.1 42.7 42.6 42.7v33.7c0 7.6 9.2 11.4 14.6 6l39.7-39.7H283.8c23.6 0 42.7-19.1 42.7-42.7V106.7c0-23.6-19.1-42.7-42.7-42.7H85.3zm99.2 219v77c0 23.6 19.1 42.7 42.7 42.7H372.8l39.7 39.7c5.4 5.4 14.6 1.6 14.6-6V402.7c22.9-.7 41.3-19.5 41.3-42.6V256.2c0-23.6-19.1-42.7-42.7-42.7H356.2c-1.6 38.7-33.4 69.5-72.5 69.5H184.5z'
      
    ]
  };

  

  
  

  var faClock = {
    prefix: 'fak',
    iconName: 'clock',
    icon: [
      512,
      512,
      [],
      'e016',
      
      'M256 54.4a201.6 201.6 0 1 1 0 403.2 201.6 201.6 0 1 1 0-403.2zM256 508A252 252 0 1 0 256 4a252 252 0 1 0 0 504zM237.7 110.9c13.9 0 25.2 11.3 25.2 25.2l0 118.8 118.8 0c13.9 0 25.2 11.3 25.2 25.2s-11.3 25.2-25.2 25.2l-144 0c-13.9 0-25.2-11.3-25.2-25.2l0-144c0-13.9 11.3-25.2 25.2-25.2z'
      
    ]
  };

  

  
  

  var fa365Logo = {
    prefix: 'fak',
    iconName: '365-logo',
    icon: [
      512,
      512,
      [],
      'e06b',
      
      'M317 512c-2.2-1-4.3-2.2-6.5-3c-85.1-31.5-170.3-62.9-255.4-94.3c-1.7-.6-3.4-1.4-4.8-3.1C139 423.8 227.7 436 316.9 448.3V79.4c-1.9 .3-3.5 .6-5.1 1c-57.2 13.7-114.4 27.4-171.6 41c-4.3 1-4.8 3.2-4.8 6.9c.1 79.7 0 159.4 .2 239c0 4.8-1.5 6.9-5.9 8.6c-27.3 10.4-54.4 21.1-81.5 31.6c-1.6 .6-3.2 1.2-5.6 2.1c0-2.4 0-4.3 0-6.1c0-98.5 0-196.9-.1-295.4c0-4.2 1.1-6.3 5.3-7.8C135.9 67.3 224.1 34 312.3 .9c3-1.1 6.9-1.2 9.9-.3C369.7 14 417 27.8 464.3 41.3c3.7 1 5.3 2.5 5.3 6.7c-.1 138.8-.1 277.6 0 416.5c0 4.2-1.5 5.6-5.3 6.6c-47 12.9-94 25.9-141 38.9c-1.8 .5-3.5 1.3-5.3 2H317z'
      
    ]
  };

  

  
  

  var faNavCalls = {
    prefix: 'fak',
    iconName: 'nav-calls',
    icon: [
      512,
      512,
      [],
      'e05d',
      
      'M213.3 135.7c-4.2-21.1-23.7-35.6-45.1-33.6l-52.9 4.8c-20.3 1.8-38.1 18.6-37.1 41.2c3.3 73.2 41.5 145 94.8 197.9c53.2 52.8 123.8 89 194 87.4c19.8-.4 34.4-15.4 37.9-32.7l9.1-45.7c4.6-22.8-10.2-45-33-49.5l-50.2-10.1c-13.8-2.8-28.1 1.6-38 11.5l-7.9 7.9c-1 1-2 1.4-2.4 1.5l-.1 0 0 0c-11.7-7.7-27.5-21.3-42.8-36.6s-28.9-31.1-36.6-42.8l0-.1 0-.1c.1-.4 .4-1.4 1.5-2.4l7.9-7.9c9.9-9.9 14.3-24.2 11.5-38l-10.5-52.7zm48 35c0-8.8 7.2-16 16-16c38.3 0 69.3 31 69.3 69.3c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-20.6-16.7-37.3-37.3-37.3c-8.8 0-16-7.2-16-16zm10.7-64c0-8.8 7.2-16 16-16c67.7 0 122.7 54.9 122.7 122.7c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-50.1-40.6-90.7-90.7-90.7c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faGear = {
    prefix: 'fak',
    iconName: 'gear',
    icon: [
      512,
      512,
      [],
      'e051',
      
      'M256 0c17 0 33.6 1.7 49.8 4.8c7.9 1.5 21.8 6.1 29.4 20.1c2 3.7 3.6 7.6 4.6 11.8l9.3 38.5C350.5 81 360.3 86.7 366 85l38-11.2c4-1.2 8.1-1.8 12.2-1.9c16.1-.5 27 9.4 32.3 15.4c22.1 25.1 39.1 54.6 49.9 86.3c2.6 7.6 5.6 21.8-2.7 35.4c-2.2 3.6-4.9 7-8 10L459 246.3c-4.2 4-4.2 15.5 0 19.5l28.7 27.3c3.1 3 5.8 6.4 8 10c8.2 13.6 5.2 27.8 2.7 35.4c-10.8 31.7-27.8 61.1-49.9 86.3c-5.3 6-16.3 15.9-32.3 15.4c-4.1-.1-8.2-.8-12.2-1.9L366 427c-5.7-1.7-15.5 4-16.9 9.8l-9.3 38.5c-1 4.2-2.6 8.2-4.6 11.8c-7.7 14-21.6 18.5-29.4 20.1C289.6 510.3 273 512 256 512s-33.6-1.7-49.8-4.8c-7.9-1.5-21.8-6.1-29.4-20.1c-2-3.7-3.6-7.6-4.6-11.8l-9.3-38.5c-1.4-5.8-11.2-11.5-16.9-9.8l-38 11.2c-4 1.2-8.1 1.8-12.2 1.9c-16.1 .5-27-9.4-32.3-15.4c-22-25.1-39.1-54.6-49.9-86.3C11 330.8 8 316.6 16.3 303c2.2-3.6 4.9-7 8-10L53 265.7c4.2-4 4.2-15.5 0-19.5L24.2 218.9c-3.1-3-5.8-6.4-8-10C8 195.3 11 181.1 13.6 173.6c10.8-31.7 27.8-61.1 49.9-86.3c5.3-6 16.3-15.9 32.3-15.4c4.1 .1 8.2 .8 12.2 1.9L146 85c5.7 1.7 15.5-4 16.9-9.8l9.3-38.5c1-4.2 2.6-8.2 4.6-11.8c7.7-14 21.6-18.5 29.4-20.1C222.4 1.7 239 0 256 0zM218.1 51.4l-8.5 35.1c-7.8 32.3-45.3 53.9-77.2 44.6L97.9 120.9c-16.5 19.3-29.5 41.7-38 65.7l26.2 24.9c24 22.8 24 66.2 0 89L59.9 325.4c8.5 24 21.5 46.4 38 65.7l34.6-10.2c31.8-9.4 69.4 12.3 77.2 44.6l8.5 35.1c24.6 4.5 51.3 4.5 75.9 0l8.5-35.1c7.8-32.3 45.3-53.9 77.2-44.6l34.6 10.2c16.5-19.3 29.5-41.7 38-65.7l-26.2-24.9c-24-22.8-24-66.2 0-89l26.2-24.9c-8.5-24-21.5-46.4-38-65.7l-34.6 10.2c-31.8 9.4-69.4-12.3-77.2-44.6l-8.5-35.1c-24.6-4.5-51.3-4.5-75.9 0zM208 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192z'
      
    ]
  };

  

  
  

  var faMinus = {
    prefix: 'fak',
    iconName: 'minus',
    icon: [
      512,
      512,
      [],
      'e023',
      
      'M104 256c0-13.3 10.7-24 24-24l256 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-256 0c-13.3 0-24-10.7-24-24z'
      
    ]
  };

  

  
  

  var faCalendarClock = {
    prefix: 'fak',
    iconName: 'calendar-clock',
    icon: [
      512,
      512,
      [],
      'e006',
      
      'M367.3 54.9c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 9.1-127 0 0-9.1c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 9.1L112 64c-35.3 0-64 28.7-64 64l0 288c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64l-32.7 0 0-9.1zM320.5 112c3.2 9.5 12.2 16.3 22.7 16.3s19.5-6.8 22.7-16.3l34 0c8.8 0 16 7.2 16 16l0 30.9-320 0L96 128c0-8.8 7.2-16 16-16l33.6 0c3.2 9.5 12.2 16.3 22.7 16.3s19.5-6.8 22.7-16.3l129.5 0zM96 206.9l320 0L416 416c0 8.8-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16l0-209.1z'
      
    ]
  };

  

  
  

  var faPaperclip = {
    prefix: 'fak',
    iconName: 'paperclip',
    icon: [
      512,
      512,
      [],
      'e029',
      
      'M433 141.5c1 27.7-9.8 55.9-33.9 80L252 368.6c-14.9 14.9-32.5 23.1-50.5 23.6c-17.8 .6-34.1-6.4-45.7-18s-18.6-27.9-18-45.7c.6-17.9 8.7-35.5 23.6-50.5L274.7 164.9c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L195.5 312c-7.7 7.7-9.5 14.1-9.6 18.1c-.1 4.1 1.4 7.7 3.9 10.2s6 4.1 10.2 3.9c4-.1 10.4-1.9 18.1-9.6L365.2 187.6c15.5-15.5 20.3-31.1 19.9-44.4c-.5-13.8-6.7-27.3-17-37.6s-23.8-16.6-37.6-17c-13.3-.5-29 4.4-44.4 19.9L138.9 255.4c-25.5 25.5-34.5 52.3-33.8 76.1c.7 24.3 11.5 47.4 28.7 64.7s40.2 28.2 64.4 28.9c23.7 .7 50.6-8.2 76.5-34.1L399.1 266.8c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L308.6 425.2c-34.4 34.3-73.8 49.2-111.9 48.1c-37.6-1.1-71.9-17.9-97-43.1S58.3 370.5 57.2 333c-1.1-38 13.7-77.3 47.8-111.5L252 74.4c24.1-24.1 52.3-34.8 80-33.9c27.2 .9 51.9 13.1 69.9 31.1s30.1 42.7 31.1 69.9z'
      
    ]
  };

  

  
  

  var faWarningBold = {
    prefix: 'fak',
    iconName: 'warning-bold',
    icon: [
      512,
      512,
      [],
      'e049',
      
      'M304.5 60c-21.6-37.3-75.4-37.3-97 0L13.5 396C-8 433.3 18.9 480 62 480l388 0c43.1 0 70.1-46.7 48.5-84L304.5 60zM256 315.2c-13.3 0-24-10.7-24-24l0-96c0-13.3 10.7-24 24-24s24 10.7 24 24l0 96c0 13.3-10.7 24-24 24zm0 80.4a24 24 0 1 1 0-48 24 24 0 1 1 0 48z'
      
    ]
  };

  

  
  

  var faTrash = {
    prefix: 'fak',
    iconName: 'trash',
    icon: [
      512,
      512,
      [],
      'e030',
      
      'M214 68.9l83.9 0 0 45.8-83.9 0 0-45.8zM346 114.7l0-46.4c0-12.1-4.5-24-12.9-33c-8.5-9.1-20.3-14.5-33.1-14.5l-87.9 0c-12.7 0-24.6 5.4-33.1 14.5c-8.4 9-12.9 20.9-12.9 33l0 46.4-63.7 0c-.2 0-.3 0-.5 0l-21.8 0c-13.3 0-24 10.7-24 24c0 13.2 10.6 23.9 23.8 24l20.2 258.5c.2 18 7 35.4 19.4 48.6c12.6 13.4 30.1 21.3 48.6 21.3l175.9 0c18.5 0 36-7.9 48.6-21.3c12.3-13.1 19.1-30.6 19.4-48.6l20.2-258.5c13.2-.1 23.8-10.8 23.8-24c0-13.3-10.7-24-24-24l-21.8 0c-.2 0-.3 0-.5 0l-63.7 0zM128 162.7l255.9 0L364 418.3c0 .6-.1 1.2-.1 1.9c0 6.6-2.5 12.6-6.4 16.8c-3.9 4.1-8.8 6.2-13.6 6.2l-175.9 0c-4.8 0-9.7-2-13.6-6.2c-3.9-4.2-6.4-10.2-6.4-16.8c0-.6 0-1.2-.1-1.9L128 162.7zm84 45.8c-13.3 0-24 10.7-24 24l0 140.7c0 13.3 10.7 24 24 24s24-10.7 24-24l0-140.7c0-13.3-10.7-24-24-24zm87.9 0c-13.3 0-24 10.7-24 24l0 140.7c0 13.3 10.7 24 24 24s24-10.7 24-24l0-140.7c0-13.3-10.7-24-24-24z'
      
    ]
  };

  

  
  

  var faPhone = {
    prefix: 'fak',
    iconName: 'phone',
    icon: [
      512,
      512,
      [],
      'e02a',
      
      'M165.8 86.1c-1-5-5.6-8.4-10.6-7.9L84.7 84.5c-2.5 .2-4.6 1.4-5.9 2.7c-1.2 1.3-1.7 2.7-1.6 4.2C81 174.9 125.1 260.2 190 324.6C254.9 389 337.5 429.4 415.1 427.8c2 0 5.3-1.7 6.2-6.5l12.2-61c1.1-5.4-2.4-10.6-7.8-11.6l-67-13.4c-3.2-.6-6.6 .4-8.9 2.7l-10.5 10.5c-14.5 14.5-39.5 22.3-61.4 7.9c-19.3-12.7-43-33.3-64.4-54.8s-42.1-45.1-54.8-64.4c-14.3-21.8-6.6-46.9 7.9-61.4l10.5-10.5c2.3-2.3 3.4-5.7 2.7-8.9L165.8 86.1zM151.1 32.1c28.6-2.6 54.5 16.8 60.1 44.9l14.1 70.3c3.7 18.4-2.1 37.4-15.3 50.7l-10.5 10.5c-1.4 1.4-1.8 2.7-1.9 3.2c0 .1 0 .1 0 .2c10.2 15.6 28.4 36.7 48.8 57.1s41.5 38.6 57.1 48.8c0 0 .1 0 .2 0c.6-.1 1.8-.6 3.2-1.9l10.5-10.5c13.3-13.3 32.3-19 50.7-15.3l67 13.4c30.4 6.1 50.1 35.6 44 66l-12.2 61c-4.6 23.1-24.1 43-50.5 43.6c-93.7 2-187.8-46.2-258.7-116.6C86.4 286.9 35.4 191.1 31.1 93.5C29.7 63.4 53.5 41 80.5 38.5l70.5-6.4z'
      
    ]
  };

  

  
  

  var faPreviousBold = {
    prefix: 'fak',
    iconName: 'previous-bold',
    icon: [
      512,
      512,
      [],
      'e056',
      
      'M104.3 448c13.3 0 24-10.7 24-24l0-336c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 336c0 13.3 10.7 24 24 24zM199 231.1c-15.9 12.8-15.9 37 0 49.8l194.4 157c20.9 16.9 52.1 2 52.1-24.9l0-314c0-26.9-31.2-41.8-52.1-24.9L199 231.1z'
      
    ]
  };

  

  
  

  var faNavAnalytics = {
    prefix: 'fak',
    iconName: 'nav-analytics',
    icon: [
      512,
      512,
      [],
      'e05b',
      
      'M85.3 256c0-11.8 9.6-21.3 21.3-21.3h42.7c11.8 0 21.3 9.6 21.3 21.3V426.7c0 11.8-9.6 21.3-21.3 21.3H106.7c-11.8 0-21.3-9.6-21.3-21.3V256zm128-170.7c0-11.8 9.6-21.3 21.3-21.3h42.7c11.8 0 21.3 9.6 21.3 21.3V426.7c0 11.8-9.6 21.3-21.3 21.3H234.7c-11.8 0-21.3-9.6-21.3-21.3V85.3zm128 85.3c0-11.8 9.6-21.3 21.3-21.3h42.7c11.8 0 21.3 9.6 21.3 21.3v256c0 11.8-9.6 21.3-21.3 21.3H362.7c-11.8 0-21.3-9.6-21.3-21.3v-256z'
      
    ]
  };

  

  
  

  var faSettings = {
    prefix: 'fak',
    iconName: 'settings',
    icon: [
      512,
      512,
      [],
      'e04e',
      
      'M312.6 312.6A80 80 0 1 0 199.4 199.4 80 80 0 1 0 312.6 312.6zm-79.2-79.2a32 32 0 1 1 45.3 45.3 32 32 0 1 1 -45.3-45.3zM240 23.2c9.9-5.7 22.1-5.7 32 0L449.6 125.8c9.9 5.7 16 16.3 16 27.7l0 205c0 11.4-6.1 22-16 27.7L272 488.8c-9.9 5.7-22.1 5.7-32 0L62.4 386.2c-9.9-5.7-16-16.3-16-27.7l0-205c0-11.4 6.1-22 16-27.7L240 23.2zM94.4 162.7l0 186.6L256 442.6l161.6-93.3 0-186.6L256 69.4 94.4 162.7z'
      
    ]
  };

  

  
  

  var faWrench = {
    prefix: 'fak',
    iconName: 'wrench',
    icon: [
      512,
      512,
      [],
      'e038',
      
      'M378.7 87.3c5.6-5.6 8-13.5 6.6-21.2s-6.5-14.3-13.7-17.6C303.9 17.6 221.1 30 165.3 85.9c-50.6 50.6-60.5 125.9-41.4 188L49 348.9c-9.4 9.4-9.4 24.6 0 33.9v0c9.4 9.4 24.6 9.4 33.9 0l85.6-85.6c6.8-6.8 8.9-17 5.3-25.9c-20.3-50.7-13.1-113 25.4-151.5C231.2 87.9 275 75.1 316.5 81.6l-58.7 58.7c-21.9 21.9-21.9 57.3 0 79.2l34 34c21.9 21.9 57.3 21.9 79.2 0l58.7-58.7c6.5 41.5-6.3 85.4-38.2 117.3c-37.7 37.7-100.4 44.1-151.2 24.6c-8.8-3.4-18.9-1.3-25.6 5.4l-86.2 86.2c-9.4 9.4-9.4 24.6 0 33.9v0c9.4 9.4 24.6 9.4 33.9 0l75.7-75.7c61.3 18.2 137 9.8 187.3-40.6c55.8-55.8 68.3-138.6 37.4-206.4c-3.3-7.2-9.8-12.3-17.6-13.7s-15.7 1.1-21.2 6.6l-87 87c-3.1 3.1-8.2 3.1-11.3 0l-34-34c-3.1-3.1-3.1-8.2 0-11.3l87-87z'
      
    ]
  };

  

  
  

  var faOdometer = {
    prefix: 'fak',
    iconName: 'odometer',
    icon: [
      512,
      512,
      [],
      'e027',
      
      'M105.4 176.7c0-13.3 10.7-24 24-24h71.5c1 0 2 .1 2.9 .2c1-.1 1.9-.2 2.9-.2c13.3 0 24 10.7 24 24v44.9c0 13.3-10.7 24-24 24s-24-10.7-24-24V200.7H129.4c-13.3 0-24-10.7-24-24zm205.2-24c-26.5 0-48 21.5-48 48v20.9c0 13.3 10.7 24 24 24s24-10.7 24-24V200.7h48v20.9c0 13.3 10.7 24 24 24s24-10.7 24-24V200.7c0-26.5-21.5-48-48-48h-48zm48 206.6c26.5 0 48-21.5 48-48V290.4c0-13.3-10.7-24-24-24s-24 10.7-24 24v20.9h-48V290.4c0-13.3-10.7-24-24-24s-24 10.7-24 24v20.9c0 26.5 21.5 48 48 48h48zm-151.9 0c-13.3 0-24-10.7-24-24V290.4c0-13.3 10.7-24 24-24s24 10.7 24 24v44.9c0 13.3-10.7 24-24 24zM62.6 81.7c-30.9 0-56 25.1-56 56l0 236.6c0 30.9 25.1 56 56 56l386.9 0c30.9 0 56-25.1 56-56l0-236.6c0-30.9-25.1-56-56-56l-386.9 0zm-8 56c0-4.4 3.6-8 8-8l386.9 0c4.4 0 8 3.6 8 8l0 236.6c0 4.4-3.6 8-8 8l-386.9 0c-4.4 0-8-3.6-8-8l0-236.6z'
      
    ]
  };

  

  
  

  var faMenu = {
    prefix: 'fak',
    iconName: 'menu',
    icon: [
      512,
      512,
      [],
      'e021',
      
      'M32 103.9c0-13.3 10.8-24 24.1-24l399.9 0c13.3 0 24.1 10.7 24.1 24s-10.8 24-24.1 24l-399.9 0c-13.3 0-24.1-10.7-24.1-24zM32 256c0-13.3 10.8-24 24.1-24l399.9 0c13.3 0 24.1 10.7 24.1 24s-10.8 24-24.1 24L56.1 280C42.8 280 32 269.3 32 256zm0 152c0-13.3 10.8-24 24.1-24l399.9 0c13.3 0 24.1 10.7 24.1 24s-10.8 24-24.1 24l-399.9 0c-13.3 0-24.1-10.7-24.1-24z'
      
    ]
  };

  

  
  

  var faNavWebsite = {
    prefix: 'fak',
    iconName: 'nav-website',
    icon: [
      512,
      512,
      [],
      'e064',
      
      'M106.7 106.7c-23.6 0-42.7 19.1-42.7 42.7l0 213.3c0 23.6 19.1 42.7 42.7 42.7l298.7 0c23.6 0 42.7-19.1 42.7-42.7l0-213.3c0-23.6-19.1-42.7-42.7-42.7l-298.7 0zM96 362.7L96 193l320 0 0 169.7c0 5.9-4.8 10.7-10.7 10.7l-298.7 0c-5.9 0-10.7-4.8-10.7-10.7zm12.9-223.4a13.9 13.9 0 1 1 0 27.7 13.9 13.9 0 1 1 0-27.7zm32.4 13.9a13.9 13.9 0 1 1 27.7 0 13.9 13.9 0 1 1 -27.7 0zm60.1-13.9a13.9 13.9 0 1 1 0 27.7 13.9 13.9 0 1 1 0-27.7zm-72.9 102c0-8.8 7.2-16 16-16l196.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-196.9 0c-8.8 0-16-7.2-16-16zm0 59.2c0-8.8 7.2-16 16-16l112.7 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-112.7 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faPin = {
    prefix: 'fak',
    iconName: 'pin',
    icon: [
      512,
      512,
      [],
      'e02b',
      
      'M252.7 132.6a84.1 84.1 0 1 0 0 168.2 84.1 84.1 0 1 0 0-168.2zm33.7 84.1a33.7 33.7 0 1 1 -67.4 0 33.7 33.7 0 1 1 67.4 0zM238.7 493l14-21-14 21c8.5 5.6 19.5 5.7 28 0l-14-21 14 21c0 0 .1 0 .1-.1l.1-.1 .5-.3 1.7-1.1c1.4-1 3.5-2.4 6-4.3c5.1-3.7 12.3-9.1 21-15.9c17.2-13.7 40.2-33.5 63.3-57.9c45.2-47.7 95.3-117.7 95.3-196.5c0-53.6-21.3-104.9-59.1-142.8s-89.2-59.1-142.8-59.1s-104.9 21.3-142.8 59.1s-59.1 89.2-59.1 142.8c0 78.9 50.1 148.8 95.3 196.5c23.1 24.4 46.1 44.2 63.3 57.9c8.6 6.9 15.8 12.2 21 15.9c2.6 1.8 4.6 3.3 6 4.3l1.7 1.1 .5 .3 .1 .1c0 0 0 0 .1 0zM145.6 109.6c28.4-28.4 67-44.4 107.1-44.4s78.7 16 107.1 44.4s44.4 67 44.4 107.1c0 58.6-38.3 116.3-81.5 161.9c-21.1 22.2-42.2 40.5-58.2 53.2c-4.4 3.5-8.4 6.6-11.9 9.2c-3.5-2.6-7.5-5.7-11.9-9.2c-15.9-12.7-37.1-30.9-58.2-53.2c-43.2-45.6-81.5-103.3-81.5-161.9c0-40.2 16-78.7 44.4-107.1z'
      
    ]
  };

  

  
  

  var faSend = {
    prefix: 'fak',
    iconName: 'send',
    icon: [
      512,
      512,
      [],
      'e047',
      
      'M84.3 42.5c-8.7-4.3-19.1-3-26.5 3.3s-10.1 16.5-7 25.7L112.2 256 50.8 440.4c-3.1 9.2-.3 19.4 7 25.7s17.8 7.7 26.5 3.3l384-192c8.1-4.1 13.3-12.4 13.3-21.5s-5.1-17.4-13.3-21.5l-384-192zM154.8 232L114.6 111.4 355.9 232l-201 0zm0 48l201 0L114.6 400.6 154.8 280z'
      
    ]
  };

  

  
  

  var faDollar = {
    prefix: 'fak',
    iconName: 'dollar',
    icon: [
      512,
      512,
      [],
      'e012',
      
      'M256 28.5c13.3 0 24 10.7 24 24v49.4c9.8 .6 19.2 1.7 27.9 3.1c18.7 3 36.2 7.6 46.9 12.9c11.9 5.9 16.7 20.3 10.7 32.2s-20.3 16.7-32.2 10.7c-4-2-15.8-5.7-32.9-8.4c-16.5-2.6-35.5-3.9-53.3-2.4c-18.2 1.6-32.6 5.9-41.9 12.4c-7.9 5.6-13.2 13.4-13.2 27.5c0 6.7 1.6 10.9 3.5 13.8c2.1 3.2 5.7 6.5 11.7 9.8c12.3 6.9 29.2 11.2 50.8 16.6l3.9 1c21.4 5.4 47.5 12.3 68 26c22.5 15.1 38.1 38.4 38.1 72.8c0 32.2-11.9 56.5-33.5 71.8c-16.2 11.5-35.8 16.3-54.5 17.7v40.1c0 13.3-10.7 24-24 24s-24-10.7-24-24V417.1c-32.5-4.9-61.9-15.3-74.7-21.7c-11.9-5.9-16.7-20.3-10.7-32.2s20.3-16.7 32.2-10.7c11.9 6 52.3 19.4 88.3 19.4c18 0 31.4-3.4 39.7-9.3c6.9-4.9 13.3-13.5 13.3-32.7c0-17-6.4-25.9-16.9-32.9c-12.5-8.4-30.4-13.6-53-19.4c-1.8-.5-3.7-.9-5.6-1.4c-19.5-4.9-42.6-10.7-60.8-20.9c-10.5-5.9-20.7-13.9-28.2-25.2c-7.7-11.5-11.6-25.1-11.6-40.4c0-29.9 13.1-52.3 33.6-66.7c16-11.3 35.5-17 54.4-19.7V52.5c0-13.3 10.7-24 24-24z'
      
    ]
  };

  

  
  

  var faFilter = {
    prefix: 'fak',
    iconName: 'filter',
    icon: [
      512,
      512,
      [],
      'e01b',
      
      'M40 140.8c0-13.3 10.7-24 24-24l384 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-384 0c-13.3 0-24-10.7-24-24zM116.8 256c0-13.3 10.7-24 24-24l230.4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-230.4 0c-13.3 0-24-10.7-24-24zm100.8 91.2l76.8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-76.8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z'
      
    ]
  };

  

  
  

  var faTech = {
    prefix: 'fak',
    iconName: 'tech',
    icon: [
      512,
      512,
      [],
      'e031',
      
      'M144 144a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm176 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM80 416c0-70.7 57.3-128 128-128l96 0c70.7 0 128 57.3 128 128l0 32c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32l0-32zm48 0l0 16 40 0 0-85.3c-23.9 13.8-40 39.7-40 69.3zm88 16l80 0 0-96-80 0 0 96zm128 0l40 0 0-16c0-29.6-16.1-55.5-40-69.3l0 85.3z'
      
    ]
  };

  

  
  

  var faSort = {
    prefix: 'fak',
    iconName: 'sort',
    icon: [
      512,
      512,
      [],
      'e034',
      
      'M237.9 37c10-10 26.2-10 36.2 0L420.8 183.7c16.1 16.1 4.7 43.7-18.1 43.7l-293.4 0c-22.8 0-34.2-27.6-18.1-43.7L237.9 37zM163.4 179.4l185.3 0L256 86.8l-92.6 92.6zM274.1 475c-10 10-26.2 10-36.2 0L91.2 328.3c-16.1-16.1-4.7-43.7 18.1-43.7l293.4 0c22.8 0 34.2 27.6 18.1 43.7L274.1 475zm74.5-142.4l-185.3 0L256 425.2l92.6-92.6z'
      
    ]
  };

  

  
  

  var faMore = {
    prefix: 'fak',
    iconName: 'more',
    icon: [
      512,
      512,
      [],
      'e025',
      
      'M217.7 102.5a38.4 38.4 0 1 0 76.8 0 38.4 38.4 0 1 0 -76.8 0zm38.3 115.2a38.3 38.3 0 1 1 .1 76.7 38.3 38.3 0 1 1 -.1-76.7zm.1 153.5a38.4 38.4 0 1 1 0 76.8 38.4 38.4 0 1 1 0-76.8z'
      
    ]
  };

  

  
  

  var faHappy = {
    prefix: 'fak',
    iconName: 'happy',
    icon: [
      512,
      512,
      [],
      'e069',
      
      'M256 396.8c22.6 0 44.1-4.9 64.3-14.7s36.6-24.1 49-42.9c4.7-7.3 5.3-14.4 1.9-21.4s-9-10.6-16.6-10.6c-3.4 0-6.5 .7-9.3 2.2s-5 3.7-6.7 6.7c-9.8 13.2-22 23.6-36.5 31s-29.9 11.2-46.1 11.2s-31.6-3.7-46.1-11.2s-26.7-17.8-36.5-31c-2.1-3-4.6-5.2-7.4-6.7s-5.9-2.2-9.3-2.2c-7.7 0-13.2 3.4-16.6 10.2s-2.8 13.7 1.9 20.5c12.4 19.2 28.7 33.8 49 43.8s41.9 15 65 15zm89.6-166.4a38.4 38.4 0 1 0 0-76.8 38.4 38.4 0 1 0 0 76.8zm-179.2 0a38.4 38.4 0 1 0 0-76.8 38.4 38.4 0 1 0 0 76.8zM256 512c-35.4 0-68.7-6.7-99.8-20.2s-58.2-31.7-81.3-54.7s-41.3-50.1-54.7-81.3S0 291.4 0 256s6.7-68.7 20.2-99.8S51.8 97.9 74.9 74.9s50.1-41.3 81.3-54.7S220.6 0 256 0s68.7 6.7 99.8 20.2s58.2 31.7 81.3 54.7s41.3 50.1 54.7 81.3S512 220.6 512 256s-6.7 68.7-20.2 99.8s-31.7 58.2-54.7 81.3s-50.1 41.3-81.3 54.7S291.4 512 256 512zm0-51.2c57.2 0 105.6-19.8 145.3-59.5s59.5-88.1 59.5-145.3s-19.8-105.6-59.5-145.3S313.2 51.2 256 51.2s-105.6 19.8-145.3 59.5S51.2 198.8 51.2 256s19.8 105.6 59.5 145.3s88.1 59.5 145.3 59.5z'
      
    ]
  };

  

  
  

  var faPause = {
    prefix: 'fak',
    iconName: 'pause',
    icon: [
      512,
      512,
      [],
      'e052',
      
      'M144 64c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48s48-21.5 48-48V112c0-26.5-21.5-48-48-48zm224 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48s48-21.5 48-48V112c0-26.5-21.5-48-48-48z'
      
    ]
  };

  

  
  

  var faWebchat = {
    prefix: 'fak',
    iconName: 'webchat',
    icon: [
      512,
      512,
      [],
      'e037',
      
      'M128.2 32c-35.3 0-64 28.7-64 64l0 255.4c0 35.3 28.7 64 64 64l204.3 0c2.3 0 4.5 .6 6.5 1.9l84.5 53c10.7 6.7 24.5-1 24.5-13.6L448 96c0-35.3-28.7-64-64-64L128.2 32zM266.8 139.5l23.7 44.7c1.1 2.2 2.9 3.9 5.1 5.1l44.7 23.7c8.7 4.6 8.7 17 0 21.6l-44.7 23.7c-2.2 1.1-3.9 2.9-5.1 5.1l-23.7 44.7c-4.6 8.7-17 8.7-21.6 0l-23.7-44.7c-1.1-2.2-2.9-3.9-5.1-5.1l-44.7-23.7c-8.7-4.6-8.7-17 0-21.6l44.7-23.7c2.2-1.1 3.9-2.9 5.1-5.1l23.7-44.7c4.6-8.7 17-8.7 21.6 0z'
      
    ]
  };

  

  
  

  var faCircleCheck = {
    prefix: 'fak',
    iconName: 'circle-check',
    icon: [
      512,
      512,
      [],
      'e039',
      
      'M432 256A176 176 0 1 0 80 256a176 176 0 1 0 352 0zM32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm321.4-39.6L240.2 333.9c-4.5 4.6-10.6 7.3-17.1 7.4s-12.6-2.5-17.2-7l-56.4-56.4c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L222.6 283l96.2-99.9c9.2-9.5 24.4-9.8 33.9-.6s9.8 24.4 .6 33.9z'
      
    ]
  };

  

  
  

  var faChair = {
    prefix: 'fak',
    iconName: 'chair',
    icon: [
      512,
      512,
      [],
      'e000',
      
      'M136.4 31.3c-30.9 0-56 25.1-56 56l0 72.7 48 0 0-72.7c0-4.4 3.6-8 8-8l239.4 0c4.4 0 8 3.6 8 8l0 72.7 48 0 0-72.7c0-30.9-25.1-56-56-56l-239.4 0zM112 336l288 0 0-128 32 0 0 160L80 368l0-160 32 0 0 128zm48-48l0-96c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32l16 0 0 48c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-48 256 0 0 47.7c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-47.7 16 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 96-192 0z'
      
    ]
  };

  

  
  

  var faNavReviews = {
    prefix: 'fak',
    iconName: 'nav-reviews',
    icon: [
      512,
      512,
      [],
      'e062',
      
      'M215.5 398.1c-1.3-.7-2.8-.7-4.1 0l-82.5 45.6c-3.1 1.7-6.8-.9-6.3-4.4l15.9-97.3c.2-1.3-.2-2.7-1.2-3.7l-67.5-69c-2.4-2.5-1-6.7 2.4-7.2L164.9 248c1.4-.2 2.6-1.1 3.2-2.4l41.3-88c1.5-3.3 6.2-3.3 7.7 0l41.3 88c.6 1.3 1.8 2.2 3.2 2.4l92.7 14.1c3.4 .5 4.8 4.7 2.4 7.2l-67.5 69c-.9 1-1.4 2.3-1.2 3.7l15.9 97.3c.6 3.5-3.2 6.1-6.3 4.4l-82.3-45.6zM213.3 187l-30.7 65.4c-2.9 6.1-8.6 10.4-15.3 11.4L97.2 274.5l51.5 52.7c4.5 4.6 6.5 11.1 5.5 17.4l-12 73.4 61.4-33.9c6.1-3.4 13.5-3.4 19.6 0L284.4 418l-12-73.4c-1-6.4 1-12.8 5.5-17.4l51.5-52.7-70.1-10.7c-6.7-1-12.4-5.3-15.3-11.4L213.3 187zM195 150.8c7.3-15.5 29.4-15.5 36.7 0l38.7 82.4 86.5 13.2c16.3 2.5 23 22.4 11.4 34.2L305 345.3l14.9 91.4c2.7 16.7-15 29.2-29.8 21l-76.6-42.5-76.9 42.5c-14.8 8.2-32.5-4.3-29.8-21l14.9-91.4L58.4 280.5c-11.5-11.8-4.9-31.7 11.4-34.2l86.5-13.2L195 150.8zm57.8-56.2c-5.2 6.4-4.2 15.8 2.3 21s15.8 4.2 21-2.3l40.2-49.8c5.2-6.4 4.2-15.8-2.3-21s-15.8-4.2-21 2.3L252.7 94.5zm46.7 100.9c-9.2-7.4-10.6-20.9-3.1-30l94-116c7.4-9.2 20.9-10.6 30-3.1s10.6 20.9 3.1 30l-94 116c-7.4 9.2-20.9 10.6-30 3.1zm88.5 27.1c-6.4-5.2-7.4-14.6-2.3-21l40.2-49.8c5.2-6.4 14.6-7.4 21-2.3s7.4 14.6 2.3 21l-40.2 49.8c-5.2 6.4-14.6 7.4-21 2.3z'
      
    ]
  };

  

  
  

  var faNeutral = {
    prefix: 'fak',
    iconName: 'neutral',
    icon: [
      512,
      512,
      [],
      'e066',
      
      'M345.6 230.4a38.4 38.4 0 1 0 0-76.8 38.4 38.4 0 1 0 0 76.8zm-179.2 0a38.4 38.4 0 1 0 0-76.8 38.4 38.4 0 1 0 0 76.8zm32 115.2H313.6c5.5 0 10.1-1.8 13.8-5.4s5.4-8.2 5.4-13.8s-1.8-10.1-5.4-13.8s-8.2-5.4-13.8-5.4H198.4c-5.5 0-10.1 1.8-13.8 5.4s-5.4 8.2-5.4 13.8s1.8 10.1 5.4 13.8s8.2 5.4 13.8 5.4zM256 512c-35.4 0-68.7-6.7-99.8-20.2s-58.2-31.7-81.3-54.7s-41.3-50.1-54.7-81.3S0 291.4 0 256s6.7-68.7 20.2-99.8S51.8 97.9 74.9 74.9s50.1-41.3 81.3-54.7S220.6 0 256 0s68.7 6.7 99.8 20.2s58.2 31.7 81.3 54.7s41.3 50.1 54.7 81.3S512 220.6 512 256s-6.7 68.7-20.2 99.8s-31.7 58.2-54.7 81.3s-50.1 41.3-81.3 54.7S291.4 512 256 512zm0-51.2c57.2 0 105.6-19.8 145.3-59.5s59.5-88.1 59.5-145.3s-19.8-105.6-59.5-145.3S313.2 51.2 256 51.2s-105.6 19.8-145.3 59.5S51.2 198.8 51.2 256s19.8 105.6 59.5 145.3s88.1 59.5 145.3 59.5z'
      
    ]
  };

  

  
  

  var faNavTasks = {
    prefix: 'fak',
    iconName: 'nav-tasks',
    icon: [
      512,
      512,
      [],
      'e063',
      
      'M128 64c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L128 64zm122.2 77.9c7 5.4 8.2 15.5 2.8 22.5l-58.1 74.8c-2.8 3.6-7.1 5.9-11.6 6.2s-9.1-1.4-12.3-4.7l-32.1-32.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l19.3 19.3 47-60.4c5.4-7 15.5-8.2 22.5-2.8zm0 128.2c7 5.4 8.2 15.5 2.8 22.5l-58.1 74.7c-2.8 3.6-7.1 5.9-11.6 6.2s-9.1-1.4-12.3-4.7l-32.1-32.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l19.3 19.3 46.9-60.4c5.4-7 15.5-8.2 22.5-2.8zm58.3-89.8l53.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-53.3 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 144.9c0-8.8 7.2-16 16-16l53.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-53.3 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faCancel = {
    prefix: 'fak',
    iconName: 'cancel',
    icon: [
      512,
      512,
      [],
      'e015',
      
      'M47.7 428.6c-9.8 9.8-9.8 25.8 0 35.6s25.8 9.8 35.6 0L256 291.6 428.6 464.3c9.8 9.8 25.8 9.8 35.6 0s9.8-25.8 0-35.6L291.6 256 464.3 83.4c9.8-9.8 9.8-25.8 0-35.6s-25.8-9.8-35.6 0L256 220.4 83.4 47.7c-9.8-9.8-25.8-9.8-35.6 0s-9.8 25.8 0 35.6L220.4 256 47.7 428.6z'
      
    ]
  };

  

  
  

  var faWarning = {
    prefix: 'fak',
    iconName: 'warning',
    icon: [
      512,
      512,
      [],
      'e044',
      
      'M256 315.6c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24s24 10.7 24 24v96c0 13.3-10.7 24-24 24zm0 31.9a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM207.5 60c21.6-37.3 75.4-37.3 97 0l194 336c21.6 37.3-5.4 84-48.5 84L62 480c-43.1 0-70-46.7-48.5-84l194-336zm55.4 24c-3.1-5.3-10.8-5.3-13.9 0L55.1 420c-3.1 5.3 .8 12 6.9 12l388 0c6.2 0 10-6.7 6.9-12L262.9 84z'
      
    ]
  };

  

  
  

  var faNavSettings = {
    prefix: 'fak',
    iconName: 'nav-settings',
    icon: [
      512,
      512,
      [],
      'e061',
      
      'M211.9 181.2c-8.3-16.2-31.5-16.2-39.7 0l-8.5 16.7c-5.3 10.4-17.8 15-28.6 10.4L117.8 201c-16.8-7.1-34.5 7.8-30.4 25.5l4.2 18.3c2.6 11.4-4 22.9-15.2 26.3l-17.9 5.5C41 281.9 37 304.8 51.6 315.7l15 11.3c9.4 7 11.7 20.1 5.3 30L61.6 372.7C51.7 387.9 63.3 408 81.5 407l18.7-1c11.7-.6 21.9 7.9 23.3 19.6l2.3 18.6c2.2 18.1 24 26 37.3 13.6L176.8 445c8.6-8 21.9-8 30.4 0l13.7 12.8c13.3 12.4 35.1 4.5 37.3-13.6l2.3-18.6c1.4-11.6 11.6-20.2 23.3-19.6l18.7 1c18.2 1 29.8-19.1 19.9-34.4l-10.2-15.7c-6.4-9.8-4.1-22.9 5.3-30l15-11.3c14.6-10.9 10.5-33.8-6.9-39.1l-17.9-5.5c-11.2-3.4-17.9-14.9-15.2-26.3l4.2-18.3c4.1-17.8-13.7-32.7-30.4-25.5l-17.3 7.4c-10.8 4.6-23.3 0-28.6-10.4l-8.5-16.7zM192 253.5a66.8 66.8 0 1 1 0 133.6 66.8 66.8 0 1 1 0-133.6zM401.4 52.7c-3.4-11.2-18-13.9-25.1-4.5L369 57.8c-4.6 6-13 7.4-19.3 3.3l-10.1-6.6c-9.8-6.4-22.7 1-22.2 12.7l.6 12c.4 7.5-5.2 14-12.6 14.9l-12 1.4c-11.6 1.4-16.8 15.4-8.8 24l8.2 8.8c5.1 5.5 5.1 14.1-.1 19.6l-8.3 8.8c-8 8.5-3 22.6 8.6 24l12 1.5c7.5 .9 12.9 7.5 12.5 15l-.7 12c-.7 11.7 12.2 19.2 22.1 12.9l10.1-6.5c6.3-4.1 14.7-2.6 19.2 3.5l7.2 9.7c7 9.4 21.7 6.9 25.2-4.3l3.6-11.5c2.2-7.2 9.6-11.4 17-9.7L433 206c11.4 2.7 21-8.7 16.5-19.5l-4.7-11.1c-2.9-6.9 0-15 6.8-18.3l10.8-5.4c10.5-5.3 10.5-20.2 .1-25.5l-10.7-5.5c-6.7-3.4-9.6-11.5-6.6-18.4l4.8-11.1c4.6-10.8-4.9-22.2-16.3-19.6l-11.8 2.7c-7.3 1.7-14.7-2.6-16.9-9.9l-3.5-11.6zM380.6 96.2a43 43 0 1 1 -15.3 84.5 43 43 0 1 1 15.3-84.5z'
      
    ]
  };

  

  
  

  var faRightChevron = {
    prefix: 'fak',
    iconName: 'right-chevron',
    icon: [
      512,
      512,
      [],
      'e02e',
      
      'M191 47.7c-9.8-9.8-25.8-9.8-35.6 0s-9.8 25.8 0 35.6L328 256 155.4 428.6c-9.8 9.8-9.8 25.8 0 35.6s25.8 9.8 35.6 0L381.5 273.8s0 0 0 0c1.2-1.2 2.3-2.6 3.2-4c6.5-9.8 5.4-23.1-3.2-31.7c0 0 0 0 0 0L191 47.7z'
      
    ]
  };

  

  
  

  var faHint = {
    prefix: 'fak',
    iconName: 'hint',
    icon: [
      512,
      512,
      [],
      'e040',
      
      'M256 33.7c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24s-24-10.7-24-24v-16c0-13.3 10.7-24 24-24zM97.9 262.3c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24s10.7-24 24-24h16c13.3 0 24 10.7 24 24zm355.7 24c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h16zM90.4 102.6c9.6-9.2 24.8-8.9 33.9 .7l11.2 11.6c9.2 9.6 8.9 24.8-.7 33.9s-24.8 8.9-33.9-.7L89.7 136.5c-9.2-9.6-8.9-24.8 .7-33.9zm331 34.8c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-11.1 11.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l11.1-11.1zM127.8 262.6c0-70.7 57.3-128 128-128s128 57.3 128 128c0 21.9-3.8 39.4-10 54.2c-6.1 14.7-14.2 25.7-21.2 34.5c-1.1 1.5-2.2 2.8-3.3 4.2c-12 15.2-17.6 22.2-17.6 37.1l0 52c0 20.4-16.6 37-37 37l-78 0c-20.4 0-37-16.6-37-37l0-52c0-14.5-5.2-21-17-35.6c-1.2-1.5-2.4-3-3.8-4.7c-7-8.8-15.2-19.8-21.3-34.7c-6.2-15-9.9-32.8-9.9-55.1zm128-80c-44.2 0-80 35.8-80 80c0 16.7 2.8 28.2 6.3 36.7c3.6 8.7 8.4 15.5 14.4 23c1.2 1.5 2.4 3 3.7 4.6c7 8.4 15.4 18.7 21.1 32.5l68.7 0c5.7-14.1 14.2-24.6 21.2-33.3c1.2-1.5 2.4-3 3.6-4.4c6.1-7.7 11-14.7 14.6-23.3c3.6-8.5 6.3-19.7 6.3-35.7c0-44.2-35.8-80-80-80zm28 224.8l-56 0 0 26.2 56 0 0-26.2z'
      
    ]
  };

  

  
  

  var faSkipBold = {
    prefix: 'fak',
    iconName: 'skip-bold',
    icon: [
      512,
      512,
      [],
      'e055',
      
      'M407.2 64c-13.3 0-24 10.7-24 24V424c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-13.3-10.7-24-24-24zM310.8 280.9c15.9-12.8 15.9-37 0-49.8L116.4 74.1C95.5 57.2 64.3 72.1 64.3 99l0 314c0 26.9 31.2 41.8 52.1 24.9l194.4-157z'
      
    ]
  };

  

  
  

  var faUpChevron = {
    prefix: 'fak',
    iconName: 'up-chevron',
    icon: [
      512,
      512,
      [],
      'e033',
      
      'M47.7 325.8c-9.8 9.8-9.8 25.8 0 35.6s25.8 9.8 35.6 0L256 188.8 428.6 361.5c9.8 9.8 25.8 9.8 35.6 0s9.8-25.8 0-35.6L273.8 135.4v0c-1.2-1.2-2.6-2.3-4-3.2c-9.8-6.5-23.1-5.4-31.7 3.2v0L47.7 325.8z'
      
    ]
  };

  

  
  

  var faStar = {
    prefix: 'fak',
    iconName: 'star',
    icon: [
      543,
      512,
      [],
      'e045',
      
      'M271.5 68.3l-48 102.2c-4.1 8.6-12.2 14.7-21.6 16.1L92.6 203.3l80.2 82c6.4 6.5 9.2 15.6 7.8 24.6L161.9 424.4l95.9-53c8.6-4.8 19.1-4.8 27.7 0l95.6 53L362.4 310c-1.5-9 1.4-18.1 7.8-24.6l80.2-82L341 186.6c-9.4-1.4-17.5-7.5-21.6-16.1l-48-102.2zM245.6 17.2c10.3-21.9 41.5-21.9 51.8 0l59.2 126.1 132.5 20.2c23 3.5 32.4 31.6 16.2 48.3l-96.9 99.1 22.8 139.9c3.8 23.6-21.2 41.2-42.1 29.6L271.6 415.4 153.9 480.5C133 492 108 474.4 111.8 450.8l22.8-139.9L37.8 211.8c-16.3-16.7-6.9-44.8 16.2-48.3l132.5-20.2L245.6 17.2z'
      
    ]
  };

  

  
  

  var faNavCustomer = {
    prefix: 'fak',
    iconName: 'nav-customer',
    icon: [
      512,
      512,
      [],
      'e05f',
      
      'M256 277.3a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm85.3 158.8c11.8 0 21.3-9.6 21.3-21.3V393.5c0-47.1-38.2-85.3-85.3-85.3H234.7c-47.1 0-85.3 38.2-85.3 85.3v21.3c0 11.8 9.6 21.3 21.3 21.3H341.3zm8.5-306a44.8 44.8 0 1 1 89.6 0 44.8 44.8 0 1 1 -89.6 0zM162.2 210c0 1.1-.1 2.2-.1 3.4c0 26.7 11.2 50.9 29.1 68c-2 5.9-7.6 10.2-14.2 10.2l-119.5 0c-8.2 0-14.9-6.7-14.9-14.9V261.7c0-33 26.7-59.7 59.7-59.7h29.9c10.9 0 21.1 2.9 29.9 8zm158.6 71.3c17.9-17.1 29.1-41.2 29.1-68c0-1.1 0-2.3-.1-3.4c8.8-5.1 19-8 29.9-8h29.9c33 0 59.7 26.7 59.7 59.7v14.9c0 8.2-6.7 14.9-14.9 14.9l-119.5 0c-6.6 0-12.2-4.3-14.2-10.2zM117.3 174.9a44.8 44.8 0 1 0 0-89.6 44.8 44.8 0 1 0 0 89.6z'
      
    ]
  };

  

  
  

  var faUser = {
    prefix: 'fak',
    iconName: 'user',
    icon: [
      512,
      512,
      [],
      'e035',
      
      'M144 144a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm176 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM80 416c0-70.7 57.3-128 128-128l96 0c70.7 0 128 57.3 128 128l0 32c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32l0-32zm48 0l0 16 256 0 0-16c0-44.2-35.8-80-80-80l-96 0c-44.2 0-80 35.8-80 80z'
      
    ]
  };

  

  
  

  var faMagic = {
    prefix: 'fak',
    iconName: 'magic',
    icon: [
      512,
      512,
      [],
      'e04b',
      
      'M449.8 121.6c3.1 1.5 6.2 3 9.4 4.5l-.9 .4c3 1.3 5.1 3.8 5.1 7.7c0 3.4-2.1 5.5-5.1 7.3c-7.7 3.4-15.4 6.8-22.7 10.7c-18.4 9.8-32.1 24.3-41.1 43.1c-3 6-6 11.9-8.6 17.9c-1.3 3.4-3.8 5.5-7.7 5.5s-6-2.6-7.7-6c-1-2.1-1.9-4.2-2.9-6.3c-4.4-9.8-8.8-19.5-15.5-28.2c-9.8-12.8-22.2-22.6-36.8-29.4L298.8 141c-3.4-1.7-5.1-3.8-5.1-7.7c0-3.4 2.1-6 5.1-7.3c2.7-1.3 5.4-2.7 8.1-4c6.7-3.2 13.3-6.5 19.7-10.1c17.1-10.2 29.5-25.2 37.6-43.1c1.3-3.1 2.7-6 4.1-8.8c.9-1.9 1.9-3.8 2.7-5.7c1.7-3.4 3.8-6 8.1-6s6.4 3 8.1 6.4c.5 1 .9 2 1.4 3.1c3 6.7 6 13.7 9.8 20c9.8 17.5 24 30.7 41.9 39.2c3.2 1.5 6.3 3 9.4 4.5zm-101 142.3c10.7 4.7 21 9.4 31.2 14.5l-.9 .9c6 3 9.4 7.7 9.4 14.5s-3.8 11.5-9.8 14.5c-4.1 1.9-8.3 3.9-12.6 5.9c-8 3.8-16.1 7.6-24.2 11.2c-16.7 8.1-32.1 18.3-46.2 30.7c-22.2 20-38.5 44.4-50.5 71.7c-3.4 9-7.7 17.5-12 26c-3.9 8.1-11.6 11.5-19.3 9c-5.1-1.3-8.1-5.1-10.3-9.4c-2.6-5.5-5.1-11-7.7-16.4s-5.1-10.9-7.7-16.4c-17.1-37.5-43.6-67-79.6-87.4c-13.2-7.4-26.9-13.7-40.7-20c-2.8-1.3-5.6-2.6-8.5-3.9c-7.3-3.4-11.1-8.5-11.1-15.4c-.4-7.3 3.4-11.9 9.4-14.9c11.6-5.5 23.5-11.1 35.5-16.6c0 0 0 0 0 0c24-11.1 44.5-26.4 62-45.6c18-19.6 29.9-42.7 40.6-66.5c2.6-6 5.1-11.5 8.1-17.1c3-6 7.7-9.4 15-9.4c6.8 0 11.6 3.4 14.5 9.4c3.8 7.2 7.2 14.6 10.6 22c2 4.4 4 8.7 6.1 13c10.3 22.6 24.8 42.2 42.8 59.3c16.3 15.4 35.1 27.3 55.6 36.7zM183.3 328.7c13.7 13.7 25.2 29 35.9 45.6c21-33.7 47.9-60.6 81.7-81.5c-34.2-20.9-61.2-47.8-81.7-81.5c-21 33.7-47.5 60.6-81.7 81.5c17.1 10.7 32.1 22.2 45.8 35.8z'
      
    ]
  };

  

  
  

  var faBookmark = {
    prefix: 'fak',
    iconName: 'bookmark',
    icon: [
      512,
      512,
      [],
      'e005',
      
      'M226 346.5l-82 65.6L144 96c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16l0 316.1-82-65.6c-17.5-14-42.4-14-60 0zM256 384l108 86.4c21 16.8 52 1.8 52-25L416 96c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64l0 349.4c0 26.8 31 41.8 52 25L256 384z'
      
    ]
  };

  

  
  

  var faArchive = {
    prefix: 'fak',
    iconName: 'archive',
    icon: [
      512,
      512,
      [],
      'e001',
      
      'M256 206.3c13.3 0 24 10.7 24 24v93l26.9-26.9c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 398.2c-9.4 9.4-24.6 9.4-33.9 0l-67.9-67.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L232 323.3v-93c0-13.3 10.7-24 24-24zM109.6 32.6c4.6-5.5 11.3-8.6 18.4-8.6l256 0c7.1 0 13.9 3.2 18.4 8.6l80 96c3.6 4.3 5.6 9.8 5.6 15.4l0 320c0 13.3-10.7 24-24 24L48 488c-13.3 0-24-10.7-24-24l0-320c0-5.6 2-11.1 5.6-15.4l80-96zM139.2 72l-40 48 313.5 0-40-48L139.2 72zM440 168L72 168l0 272 368 0 0-272z'
      
    ]
  };

  

  
  

  var faNewMessage = {
    prefix: 'fak',
    iconName: 'new-message',
    icon: [
      512,
      512,
      [],
      'e026',
      
      'M391.8 11.1c14.8-14.8 38.7-14.8 53.5 0l55.7 55.7c14.8 14.8 14.8 38.7 0 53.5L247.8 373.4c-4.7 4.7-10.6 8.1-17.1 9.8l-75.6 19.9c-28 7.4-53.5-18.2-46.2-46.2l19.9-75.6c1.7-6.5 5.1-12.4 9.8-17.1L391.8 11.1zm26.7 35.6L373 92.2 419.8 139l45.5-45.5L418.5 46.7zM171 294.2l-16.7 63.5L217.8 341 386.4 172.4l-46.8-46.8L171 294.2zM47.3 110.3C47.3 88.6 64.9 71 86.6 71H244.1c13 0 23.6-10.6 23.6-23.6s-10.6-23.6-23.6-23.6H86.6C38.8 23.7 0 62.5 0 110.3v315C0 473.2 38.8 512 86.6 512h315c47.8 0 86.6-38.8 86.6-86.6V267.9c0-13-10.6-23.6-23.6-23.6s-23.6 10.6-23.6 23.6V425.4c0 21.7-17.6 39.4-39.4 39.4H86.6c-21.7 0-39.4-17.6-39.4-39.4v-315z'
      
    ]
  };

  

  
  

  var faQrCode = {
    prefix: 'fak',
    iconName: 'qr-code',
    icon: [
      512,
      512,
      [],
      'e067',
      
      'M284.4 512V455.1h56.9V512H284.4zm-56.9-56.9V312.9h56.9V455.1H227.6zm227.6-85.3V256H512V369.8H455.1zM398.2 256V199.1h56.9V256H398.2zM56.9 312.9V256h56.9v56.9H56.9zM0 256V199.1H56.9V256H0zM256 56.9V0h56.9V56.9H256zM42.7 128H128V42.7H42.7V128zM0 142.2V28.4C0 20.4 2.7 13.6 8.2 8.2S20.4 0 28.4 0H142.2c8.1 0 14.8 2.7 20.3 8.2s8.2 12.2 8.2 20.3V142.2c0 8.1-2.7 14.8-8.2 20.3s-12.2 8.2-20.3 8.2H28.4c-8.1 0-14.8-2.7-20.3-8.2S0 150.3 0 142.2zM42.7 469.3H128V384H42.7v85.3zM0 483.6V369.8c0-8.1 2.7-14.8 8.2-20.3s12.2-8.2 20.3-8.2H142.2c8.1 0 14.8 2.7 20.3 8.2s8.2 12.2 8.2 20.3V483.6c0 8.1-2.7 14.8-8.2 20.3s-12.2 8.2-20.3 8.2H28.4c-8.1 0-14.8-2.7-20.3-8.2S0 491.6 0 483.6zM384 128h85.3V42.7H384V128zm-42.7 14.2V28.4c0-8.1 2.7-14.8 8.2-20.3S361.7 0 369.8 0H483.6c8.1 0 14.8 2.7 20.3 8.2s8.2 12.2 8.2 20.3V142.2c0 8.1-2.7 14.8-8.2 20.3s-12.2 8.2-20.3 8.2H369.8c-8.1 0-14.8-2.7-20.3-8.2s-8.2-12.2-8.2-20.3zM398.2 512V426.7H341.3V369.8H455.1v85.3H512V512H398.2zM284.4 312.9V256H398.2v56.9H284.4zm-113.8 0V256H113.8V199.1H284.4V256H227.6v56.9H170.7zm28.4-142.2V56.9H256v56.9h56.9v56.9H199.1zM64 106.7V64h42.7v42.7H64zM64 448V405.3h42.7V448H64zM405.3 106.7V64H448v42.7H405.3z'
      
    ]
  };

  

  
  

  var faNavCalendar = {
    prefix: 'fak',
    iconName: 'nav-calendar',
    icon: [
      512,
      512,
      [],
      'e05c',
      
      'M170.7 42.7c11.8 0 21.3 9.6 21.3 21.3l0 42.7 128 0L320 64c0-11.8 9.6-21.3 21.3-21.3s21.3 9.6 21.3 21.3l0 42.7 41.4 0c23.6 0 42.7 19.1 42.7 42.7l0 256c0 23.6-19.1 42.7-42.7 42.7l-296.2 0c-23.6 0-42.7-19.1-42.7-42.7l0-256c0-23.6 19.1-42.7 42.7-42.7l41.4 0 0-42.7c0-11.8 9.6-21.3 21.3-21.3zm-70.4 174l0 175c0 11.8 9.6 21.3 21.3 21.3l268.8 0c11.8 0 21.3-9.6 21.3-21.3l0-175c0-11.8-9.6-21.3-21.3-21.3l-268.8 0c-11.8 0-21.3 9.6-21.3 21.3zm40.6 8.6c-5.9 0-10.7 4.8-10.7 10.7v42.7c0 5.9 4.8 10.7 10.7 10.7h42.7c5.9 0 10.7-4.8 10.7-10.7V236c0-5.9-4.8-10.7-10.7-10.7H140.8zm93.9 0c-5.9 0-10.7 4.8-10.7 10.7v42.7c0 5.9 4.8 10.7 10.7 10.7h42.7c5.9 0 10.7-4.8 10.7-10.7V236c0-5.9-4.8-10.7-10.7-10.7H234.7zM317.9 236c0-5.9 4.8-10.7 10.7-10.7h42.7c5.9 0 10.7 4.8 10.7 10.7v42.7c0 5.9-4.8 10.7-10.7 10.7H328.5c-5.9 0-10.7-4.8-10.7-10.7V236zm10.7 83.2c-5.9 0-10.7 4.8-10.7 10.7v42.7c0 5.9 4.8 10.7 10.7 10.7h42.7c5.9 0 10.7-4.8 10.7-10.7V329.8c0-5.9-4.8-10.7-10.7-10.7H328.5zM224 329.8c0-5.9 4.8-10.7 10.7-10.7h42.7c5.9 0 10.7 4.8 10.7 10.7v42.7c0 5.9-4.8 10.7-10.7 10.7H234.7c-5.9 0-10.7-4.8-10.7-10.7V329.8zm-83.2-10.7c-5.9 0-10.7 4.8-10.7 10.7v42.7c0 5.9 4.8 10.7 10.7 10.7h42.7c5.9 0 10.7-4.8 10.7-10.7V329.8c0-5.9-4.8-10.7-10.7-10.7H140.8z'
      
    ]
  };

  

  
  

  var faLock = {
    prefix: 'fak',
    iconName: 'lock',
    icon: [
      512,
      512,
      [],
      'e03a',
      
      'M256 80.4c37.8 0 68.5 30.7 68.5 68.5c0 3.5-.3 6.9-.8 10.2l-135.5 0c-.5-3.3-.8-6.8-.8-10.2c0-37.8 30.7-68.5 68.5-68.5zM139.5 148.9c0 4.7 .3 9.3 .8 13.9c-44.2 12-76.7 52.4-76.7 100.4l0 113.5c0 57.4 46.6 104 104 104l176.7 0c57.4 0 104-46.6 104-104l0-113.5c0-48-32.5-88.4-76.7-100.4c.5-4.6 .8-9.2 .8-13.9c0-64.3-52.2-116.5-116.5-116.5s-116.5 52.2-116.5 116.5zm28.1 58.2l176.7 0c30.9 0 56 25.1 56 56l0 113.5c0 30.9-25.1 56-56 56l-176.7 0c-30.9 0-56-25.1-56-56l0-113.5c0-30.9 25.1-56 56-56zM280 287.9c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64z'
      
    ]
  };

  

  
  

  var faCursor = {
    prefix: 'fak',
    iconName: 'cursor',
    icon: [
      512,
      512,
      [],
      'e010',
      
      'M489.8 22.2c7 7 9.2 17.4 5.8 26.7l-162 432c-3.9 10.3-14 16.9-25 16.3s-20.3-8.3-23-19L235.2 276.8 33.9 226.4c-10.7-2.7-18.4-12-19-23s6-21.2 16.3-25l432-162c9.3-3.5 19.7-1.2 26.7 5.8zm-365.2 175l137.5 34.4c9 2.3 16.1 9.3 18.3 18.3l34.4 137.5L428.9 83.1 124.6 197.2z'
      
    ]
  };

  

  
  

  var faList = {
    prefix: 'fak',
    iconName: 'list',
    icon: [
      512,
      512,
      [],
      'e020',
      
      'M44.8 72.2c-8.8 0-16 7.2-16 16l0 31.9c0 8.8 7.2 16 16 16l31.9 0c8.8 0 16-7.2 16-16l0-31.9c0-8.8-7.2-16-16-16l-31.9 0zm0 151.9c-8.8 0-16 7.2-16 16l0 31.9c0 8.8 7.2 16 16 16l31.9 0c8.8 0 16-7.2 16-16l0-31.9c0-8.8-7.2-16-16-16l-31.9 0zM28.8 392l0 31.9c0 8.8 7.2 16 16 16l31.9 0c8.8 0 16-7.2 16-16l0-31.9c0-8.8-7.2-16-16-16l-31.9 0c-8.8 0-16 7.2-16 16zM163.2 80.1c-13.3 0-24 10.7-24 24s10.7 24 24 24l290.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-290.3 0zM139.2 256c0 13.3 10.7 24 24 24l290.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-290.3 0c-13.3 0-24 10.7-24 24zm24 127.9c-13.3 0-24 10.7-24 24s10.7 24 24 24l290.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-290.3 0z'
      
    ]
  };

  

  
  

  var faSendBold = {
    prefix: 'fak',
    iconName: 'send-bold',
    icon: [
      512,
      512,
      [],
      'e043',
      
      'M57.8 45.9c7.3-6.4 17.8-7.7 26.5-3.3l384 192c8.1 4.1 13.3 12.4 13.3 21.5s-5.1 17.4-13.3 21.5l-384 192c-8.7 4.3-19.1 3-26.5-3.3s-10.1-16.5-7-25.7L96.9 301.9c4.4-13.1 16.6-21.9 30.4-21.9H293.5c13.3 0 24-10.7 24-24s-10.7-24-24-24H127.3c-13.8 0-26-8.8-30.4-21.9L50.8 71.6c-3.1-9.2-.3-19.4 7-25.7z'
      
    ]
  };

  

  
  

  var faFlag = {
    prefix: 'fak',
    iconName: 'flag',
    icon: [
      512,
      512,
      [],
      'e01c',
      
      'M103.9 51.2c14 0 25.4 11.4 25.4 25.6V89.6l54.7-13.8c30.2-7.6 62-4.1 89.9 10c36.7 18.6 79.9 18.6 116.6 0L398 82c16.3-8.3 35.5 3.7 35.5 22.1V327.8c0 10.6-6.6 20.2-16.5 24l-27.5 10.4c-36.6 13.8-77.3 11.7-112.3-5.9c-30-15.2-64.4-19-97.1-10.7l-51 12.8v76.8c0 14.2-11.3 25.6-25.4 25.6s-25.4-11.4-25.4-25.6V76.8c0-14.2 11.3-25.6 25.4-25.6zm25.4 149.7l50.7-11.1v52.4l-50.7 11.1v52.3l38.7-9.8c4-1 8-1.9 12-2.6v-51l30.8-6.7c6.6-1.4 13.2-2 19.9-1.7V182.6c10.8 .3 21.6 2.1 32 5.1l18.7 5.5v53.4l-33-9.8c-5.8-1.7-11.7-2.7-17.7-3v57.1c17.3 1.5 34.3 5.4 50.7 11.5V246.6l18 5.4c10.7 3.2 21.6 5.1 32.7 5.9V206.4c-6.2-.6-12.4-1.8-18.4-3.6l-32.3-9.6V143.6c-10.3-3-20.4-7-30.3-12c-6.5-3.3-13.4-5.6-20.4-7v57.9c-10.3-.3-20.6 .6-30.7 2.9l-20 4.4V129.6l-50.7 12.8v58.5zM332.1 319.8c13.3 1.2 26.9-.6 39.6-5.4l11.1-4.2V252.7l-6.3 1.4c-14.6 3.4-29.6 4.6-44.5 3.6v62zm50.7-119.5V143.5c-16.6 4.9-33.6 7.3-50.7 7.3v55.6c11 1.1 22.2 .4 33-2.1l17.7-4.2v.1z'
      
    ]
  };

  

  
  

  var faCalendarBlock = {
    prefix: 'fak',
    iconName: 'calendar-block',
    icon: [
      512,
      512,
      [],
      'e058',
      
      'M343.3 31.5c13.3 0 24 10.7 24 24l0 9.1 32.7 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-288 0c-35.3 0-64-28.7-64-64l0-288c0-35.3 28.7-64 64-64l32.3 0 0-9.1c0-13.3 10.7-24 24-24s24 10.7 24 24l0 9.1 127 0 0-9.1c0-13.3 10.7-24 24-24zm0 97.4c-10.6 0-19.5-6.8-22.7-16.3l-129.5 0c-3.2 9.5-12.2 16.3-22.7 16.3s-19.5-6.8-22.7-16.3l-33.6 0c-8.8 0-16 7.2-16 16l0 30.9 320 0 0-30.9c0-8.8-7.2-16-16-16l-34 0c-3.2 9.5-12.2 16.3-22.7 16.3zM96 257.4L271.1 432.5l66.4 0L112.4 207.4l-16.4 0 0 50zM404.7 431.8c6.6-2 11.3-8.1 11.3-15.3l0-39.8L246.7 207.4l-66.5 0L404.7 431.8zm11.3-123l0-101.4-101.4 0L416 308.8zM96 325.3l0 91.2c0 8.8 7.2 16 16 16l91.2 0L96 325.3z'
      
    ]
  };

  

  
  

  var faErrorBold = {
    prefix: 'fak',
    iconName: 'error-bold',
    icon: [
      512,
      512,
      [],
      'e042',
      
      'M18.5 288C7 268.2 7 243.8 18.5 224l91-157.7c11.4-19.8 32.6-32 55.4-32l182.1 0c22.9 0 44 12.2 55.4 32l91 157.7c11.4 19.8 11.4 44.2 0 64l-91 157.7c-11.4 19.8-32.6 32-55.4 32l-182.1 0c-22.9 0-44-12.2-55.4-32L18.5 288zM256 300c13.3 0 24-10.7 24-24l0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128c0 13.3 10.7 24 24 24zm0 40a24 24 0 1 0 0 48 24 24 0 1 0 0-48z'
      
    ]
  };

  

  
  

  var faReset = {
    prefix: 'fak',
    iconName: 'reset',
    icon: [
      512,
      512,
      [],
      'e02d',
      
      'M437.8 145.4c13.2-1.1 23-12.7 21.9-25.9l-7.9-95.7c-1.1-13.2-12.7-23-25.9-21.9S402.9 14.6 404 27.8l3.1 37.7C365.3 33.3 312.9 14.2 256 14.2c-137 0-248 111-248 248s111 248 248 248s248-111 248-248c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 110.5-89.5 200-200 200s-200-89.5-200-200s89.5-200 200-200c45.1 0 86.7 14.9 120.2 40.1l-38 3.1c-13.2 1.1-23 12.7-21.9 25.9s12.7 23 25.9 21.9l95.7-7.9z'
      
    ]
  };

  

  
  

  var faUnread = {
    prefix: 'fak',
    iconName: 'unread',
    icon: [
      512,
      512,
      [],
      'e032',
      
      'M416 162.5a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-337-32c0-22.1 17.9-40 40-40l142.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L119 42.5c-48.6 0-88 39.4-88 88l0 155.8c0 37.6 23.5 69.6 56.6 82.2l0 64.2c0 33.3 40.7 49.5 63.6 25.3l79.1-83.7 130.8 0c48.6 0 88-39.4 88-88l0-29.1c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 29.1c0 22.1-17.9 40-40 40l-141.1 0c-6.6 0-12.9 2.7-17.4 7.5l-66.9 70.8 0-54.7c0-12.2-9.2-22.5-21.3-23.8C94.4 323.7 79 306.8 79 286.2l0-155.8z'
      
    ]
  };

  

  
  

  var faNote = {
    prefix: 'fak',
    iconName: 'note',
    icon: [
      512,
      512,
      [],
      'e028',
      
      'M32 88c0-30.9 25.1-56 56-56L424 32c30.9 0 56 25.1 56 56l0 197.8c0 6.4-2.5 12.5-7 17L302.4 473c-4.5 4.5-10.6 7-17 7L88 480c-30.9 0-56-25.1-56-56L32 88zm56-8c-4.4 0-8 3.6-8 8L80 424c0 4.4 3.6 8 8 8l173.4 0 0-114.1c0-30.9 25.1-56 56-56l114.5 0L432 88c0-4.4-3.6-8-8-8L88 80zM397.9 309.9l-80.5 0c-4.4 0-8 3.6-8 8l0 80.3 88.5-88.3z'
      
    ]
  };

  

  
  

  var faPlaybackSpeed = {
    prefix: 'fak',
    iconName: 'playback-speed',
    icon: [
      512,
      512,
      [],
      'e065',
      
      'M220.9 352.6l125.6-80.5c6-3.9 9-9.2 9-16.1s-3-12.2-9-16.1L220.9 159.4c-6.4-4.3-13-4.6-19.7-1s-10 9.3-10 17.1V336.5c0 7.7 3.3 13.4 10 17.1s13.2 3.3 19.7-1zM24.4 281.8c7.3 0 13.9 2.4 19.7 7.1s9.8 10.7 11.9 18c2.6 9.9 5.7 19.2 9.3 28s7.8 17.5 12.6 26.1c3.9 6.4 5.5 13.3 4.8 20.6s-3.5 13.5-8.7 18.7c-4.7 4.7-10.5 6.9-17.4 6.4s-12.2-3.4-16.1-9c-9.4-13.3-17.4-27.6-23.8-42.8s-11.4-31-14.8-47.4c-1.3-6.9 .3-12.9 4.8-18s10.4-7.7 17.7-7.7zM74 111.7c5.2 5.2 7.9 11.4 8.4 18.7s-1.1 14-4.5 20c-4.7 8.6-8.9 17.4-12.6 26.4s-6.8 18.5-9.3 28.3c-2.1 7.3-6.1 13.3-11.9 18s-12.3 7.1-19.7 7.1s-13.2-2.7-17.7-8.1s-5.9-11.5-4.2-18.4c3.4-16.3 8.4-32.1 14.8-47.4s14.2-29.5 23.2-42.8c3.9-5.6 9.2-8.5 16.1-8.7s12.7 2 17.4 6.8zM110.1 437c5.2-5.6 11.5-8.6 19-9s14.5 1.3 20.9 5.2c8.6 4.7 17.3 9 26.1 12.9s17.9 7.1 27.4 9.7c7.3 2.1 13.3 6 18 11.6s7.1 12 7.1 19.3s-2.7 13.1-8.1 17.4s-11.5 5.8-18.4 4.5c-16.3-3.4-31.7-8.4-46.1-14.8s-28.5-14-42.2-22.6c-6-3.9-9.3-9.2-10-16.1s1.4-12.9 6.1-18zM229.9 25.3c0 7.3-2.3 13.7-6.8 19.3s-10.4 9.4-17.7 11.6c-9.9 2.6-19.3 5.7-28.3 9.3s-17.8 8.1-26.4 13.2c-6.4 3.9-13.4 5.5-20.9 4.8s-13.9-3.5-19-8.7s-7.4-11.3-6.8-18.4s4-12.6 10-16.4c13.7-8.6 28-16 42.8-22.2s30.4-11.1 46.7-14.5c6.9-1.3 13 .2 18.4 4.5s8.1 10.1 8.1 17.4zM461.9 256c0-48.5-14.9-91.4-44.8-128.5s-68-61.3-114.4-72.5c-6.4-1.7-11.6-5.4-15.5-11s-5.8-11.8-5.8-18.7s2.4-12.6 7.1-17.1s10.1-6.1 16.1-4.8c60.1 12 110 41.4 149.5 88.3s59.3 101.6 59.3 164.3s-19.8 117.5-59.3 164.3s-89.3 76.2-149.5 88.3c-6 1.3-11.4-.3-16.1-4.8s-7.1-10.2-7.1-17.1s1.9-13.1 5.8-18.7s9-9.2 15.5-11c46.4-11.2 84.5-35.3 114.4-72.5s44.8-80 44.8-128.5z'
      
    ]
  };

  

  
  

  var faExport = {
    prefix: 'fak',
    iconName: 'export',
    icon: [
      512,
      512,
      [],
      'e01a',
      
      'M232 304.5l-94.8-94.8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 379.5c9.4 9.4 24.6 9.4 33.9 0L408.7 243.7c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L280 304.6l0-248.4c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 248.3zM32.4 458c0-13.3 10.7-24 24-24l399.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56.4 482c-13.3 0-24-10.7-24-24z'
      
    ]
  };

  

  
  

  var faCannedReply = {
    prefix: 'fak',
    iconName: 'canned-reply',
    icon: [
      512,
      512,
      [],
      'e008',
      
      'M127.8 162.2c0-11.5 9.3-20.8 20.8-20.8h192c11.5 0 20.8 9.3 20.8 20.8s-9.3 20.8-20.8 20.8h-192c-11.5 0-20.8-9.3-20.8-20.8zm20.8 61.7c-11.5 0-20.8 9.3-20.8 20.8s9.3 20.8 20.8 20.8h128c11.5 0 20.8-9.3 20.8-20.8s-9.3-20.8-20.8-20.8h-128zM31 130.5c0-48.6 39.4-88 88-88l274.1 0c48.6 0 88 39.4 88 88l0 155.8c0 48.6-39.4 88-88 88l-162.8 0L151.2 458c-22.9 24.2-63.6 8-63.6-25.3l0-64.2C54.5 355.8 31 323.8 31 286.2l0-155.8zm88-40c-22.1 0-40 17.9-40 40l0 155.8c0 20.5 15.5 37.5 35.4 39.7c12.1 1.4 21.3 11.6 21.3 23.8l0 54.7 66.9-70.8c4.5-4.8 10.8-7.5 17.4-7.5l173.1 0c22.1 0 40-17.9 40-40l0-155.8c0-22.1-17.9-40-40-40L119 90.5z'
      
    ]
  };

  

  
  

  var faCheckmark = {
    prefix: 'fak',
    iconName: 'checkmark',
    icon: [
      512,
      512,
      [],
      'e00a',
      
      'M424.6 135.7c9.4 9.4 9.4 24.6 0 33.9L217.9 376.3c-9.4 9.4-24.6 9.4-33.9 0L87.4 279.7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L201 325.4 390.6 135.7c9.4-9.4 24.6-9.4 33.9 0z'
      
    ]
  };

  

  
  

  var faInfo = {
    prefix: 'fak',
    iconName: 'info',
    icon: [
      482,
      512,
      [],
      'e03b',
      
      'M241 229.3c12.5 0 22.6 10.1 22.6 22.6V372.3c0 12.5-10.1 22.6-22.6 22.6s-22.6-10.1-22.6-22.6V251.8c0-12.5 10.1-22.6 22.6-22.6zm0-37.6a22.6 22.6 0 1 0 0-45.2 22.6 22.6 0 1 0 0 45.2zm0 316.2A240.9 240.9 0 1 0 241 26a240.9 240.9 0 1 0 0 481.9zm0-436.7a195.8 195.8 0 1 1 0 391.5 195.8 195.8 0 1 1 0-391.5z'
      
    ]
  };

  

  
  

  var faMessage = {
    prefix: 'fak',
    iconName: 'message',
    icon: [
      512,
      512,
      [],
      'e022',
      
      'M119 90.5c-22.1 0-40 17.9-40 40l0 155.8c0 20.5 15.5 37.5 35.4 39.7c12.1 1.4 21.3 11.6 21.3 23.8l0 54.7 66.9-70.8c4.5-4.8 10.8-7.5 17.4-7.5l173.1 0c22.1 0 40-17.9 40-40l0-155.8c0-22.1-17.9-40-40-40L119 90.5zm-88 40c0-48.6 39.4-88 88-88l274.1 0c48.6 0 88 39.4 88 88l0 155.8c0 48.6-39.4 88-88 88l-162.8 0L151.2 458c-22.9 24.2-63.6 8-63.6-25.3l0-64.2C54.5 355.8 31 323.8 31 286.2l0-155.8z'
      
    ]
  };

  



export {

  faError,
  

  faMagicBold,
  

  faCampaign,
  

  faDesktop,
  

  faCirclePlus,
  

  faExit,
  

  faCircleXBold,
  

  faPhoneMissed,
  

  faSad,
  

  faDownChevron,
  

  faFast,
  

  faCircleLine,
  

  faNavCampaigns,
  

  faPlus,
  

  faGrip,
  

  faCopy,
  

  faStarBold,
  

  faArrowUp,
  

  faGenerate,
  

  faPlayBold,
  

  faEmail,
  

  faPlay,
  

  faLink,
  

  faCompany,
  

  faInfoBold,
  

  faArrowDown,
  

  faSent,
  

  faHintBold,
  

  faAppleLogo,
  

  faCircleX,
  

  faCar,
  

  faCircleDollar,
  

  faGoal,
  

  faMobile,
  

  faLockBold,
  

  faCalendarMagic,
  

  faLeftChevron,
  

  faSearch,
  

  faEdit,
  

  faArrowLink,
  

  faNavInbox,
  

  faClock,
  

  fa365Logo,
  

  faNavCalls,
  

  faGear,
  

  faMinus,
  

  faCalendarClock,
  

  faPaperclip,
  

  faWarningBold,
  

  faTrash,
  

  faPhone,
  

  faPreviousBold,
  

  faNavAnalytics,
  

  faSettings,
  

  faWrench,
  

  faOdometer,
  

  faMenu,
  

  faNavWebsite,
  

  faPin,
  

  faSend,
  

  faDollar,
  

  faFilter,
  

  faTech,
  

  faSort,
  

  faMore,
  

  faHappy,
  

  faPause,
  

  faWebchat,
  

  faCircleCheck,
  

  faChair,
  

  faNavReviews,
  

  faNeutral,
  

  faNavTasks,
  

  faCancel,
  

  faWarning,
  

  faNavSettings,
  

  faRightChevron,
  

  faHint,
  

  faSkipBold,
  

  faUpChevron,
  

  faStar,
  

  faNavCustomer,
  

  faUser,
  

  faMagic,
  

  faBookmark,
  

  faArchive,
  

  faNewMessage,
  

  faQrCode,
  

  faNavCalendar,
  

  faLock,
  

  faCursor,
  

  faList,
  

  faSendBold,
  

  faFlag,
  

  faCalendarBlock,
  

  faErrorBold,
  

  faReset,
  

  faUnread,
  

  faNote,
  

  faPlaybackSpeed,
  

  faExport,
  

  faCannedReply,
  

  faCheckmark,
  

  faInfo,
  

  faMessage,
  

};
